let subscribers = {};
function subscribe(e, t) {
  return (
    void 0 === subscribers[e] && (subscribers[e] = []),
    (subscribers[e] = [...subscribers[e], t]),
    function () {
      subscribers[e] = subscribers[e].filter((e) => e !== t);
    }
  );
}
function fetchConfig(e = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${e}` },
  };
}
function publish(e, t) {
  subscribers[e] &&
    subscribers[e].forEach((e) => {
      e(t);
    });
}
class HTMLUpdateUtility {
  static viewTransition(e, t, o = [], r = []) {
    o?.forEach((e) => e(t));
    const i = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(i, t.outerHTML);
    const s = i.firstChild,
      n = Date.now();
    (e.querySelectorAll("[id], [form]").forEach((e) => {
      (e.id && (e.id = `${e.id}-${n}`),
        e.form && e.setAttribute("form", `${e.form.getAttribute("id")}-${n}`));
    }),
      e.parentNode.insertBefore(s, e),
      (e.style.display = "none"),
      r?.forEach((e) => e(s)),
      setTimeout(() => e.remove(), 500));
  }
  static setInnerHTML(e, t) {
    ((e.innerHTML = t),
      e.querySelectorAll("script").forEach((e) => {
        const t = document.createElement("script");
        (Array.from(e.attributes).forEach((e) => {
          t.setAttribute(e.name, e.value);
        }),
          t.appendChild(document.createTextNode(e.innerHTML)),
          e.parentNode.replaceChild(t, e));
      }));
  }
}
const PUB_SUB_EVENTS = {
  cartUpdate: "cartUpdate",
  quantityUpdate: "quantityUpdate",
  variantChange: "variantChange",
  cartError: "cartError",
  facetUpdate: "facetUpdate",
  quantityRules: "quantityRules",
  quantityBoundries: "quantityBoundries",
  optionValueSelectionChange: "optionValueSelectionChange",
};
class stickyAddtoCart extends HTMLElement {
  quantityInput = void 0;
  quantityForm = void 0;
  onVariantChangeUnsubscriber = void 0;
  cartUpdateUnsubscriber = void 0;
  abortController = void 0;
  pendingRequestUrl = null;
  preProcessHtmlCallbacks = [];
  postProcessHtmlCallbacks = [];
  constructor() {
    super();
  }
  connectedCallback() {
    ((this.section = this.closest("section")),
      this.stickyAddToCartInit(),
      this.eventStickyContent(),
      (this.info = this.section.querySelector("product-info")),
      (this.onVariantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.optionValueSelectionChange,
        this.handleOptionValueChange.bind(this),
      )));
  }
  disconnectedCallback() {
    this._handleScroll &&
      window.removeEventListener("scroll", this._handleScroll);
  }
  eventStickyContent() {
    this.addEventListener("click", (e) => {
      const t = e.target.closest(
        "[data-sticky-options-btn], [data-sticky-product-close]",
      );
      if (t) {
        if (t.matches("[data-sticky-options-btn]")) {
          t.classList.toggle("active");
          const e = this.querySelector("[data-sticky-options]");
          DOMAnimations.slideToggle(e, 500);
        }
        t.matches("[data-sticky-product-close]") &&
          (e.preventDefault(),
          this.classList.remove("sticky-visible"),
          setTimeout(() => {
            this.style.display = "none";
          }, 400));
      }
    });
  }
  stickyAddToCartInit() {
    const e = this.section.querySelector(
      `#product-form-${this.sectionId}-${this.productId}`,
    );
    if (!e) return;
    const t = e.offsetTop + 500;
    ((this._handleScroll = () => {
      const o = !isOnScreen(e, !0) && window.scrollY >= t;
      this.classList.toggle("sticky-visible", o);
    }),
      window.removeEventListener("scroll", this._handleScroll),
      window.addEventListener("scroll", this._handleScroll),
      this._handleScroll());
  }
  handleOptionValueChange({
    data: { event: e, target: t, selectedOptionValues: o },
  }) {
    if (!this.contains(e.target)) return;
    const r = "sticky-product" === this.sectionId,
      i =
        (window.scrollY,
        t.dataset.productUrl || this.pendingRequestUrl || this.dataset.url);
    this.pendingRequestUrl = i;
    const s = this.dataset.url !== i,
      n = "true" === this.dataset.updateUrl && s;
    this.renderProductInfo({
      requestUrl: this.buildRequestUrlWithParams(i, o, n),
      targetId: t.id,
      callback: (e) => {
        ((s
          ? this.info.handleSwapProduct(i, n)
          : this.info.handleUpdateProductInfo(i))(e),
          (() => {
            if (r) {
              const e = document.querySelector(
                "[data-sticky-products-wrapper]",
              );
              e && e.classList.add("show");
            }
          })());
      },
    });
  }
  renderProductInfo({ requestUrl: e, targetId: t, callback: o }) {
    (this.abortController?.abort(),
      (this.abortController = new AbortController()),
      fetch(e, { signal: this.abortController.signal })
        .then((e) => e.text())
        .then((e) => {
          this.pendingRequestUrl = null;
          const t = new DOMParser().parseFromString(e, "text/html");
          o(t);
        })
        .then(() => {})
        .catch((e) => {
          "AbortError" === e.name
            ? console.log("Fetch aborted by user")
            : console.error(e);
        }));
  }
  buildRequestUrlWithParams(e, t, o = !1) {
    const r = [];
    return (
      !o && r.push(`section_id=${this.sectionId}`),
      t.length && r.push(`option_values=${t.join(",")}`),
      `${e}?${r.join("&")}`
    );
  }
  get variantSelectors() {
    return this.querySelector("variant-selects");
  }
  get sectionId() {
    return this.dataset.originalSection || this.dataset.section;
  }
  get productId() {
    return this.getAttribute("data-product-id");
  }
}
customElements.define("sticky-addto-cart", stickyAddtoCart);
class ProductInfo extends HTMLElement {
  quantityInput = void 0;
  quantityForm = void 0;
  onVariantChangeUnsubscriber = void 0;
  cartUpdateUnsubscriber = void 0;
  abortController = void 0;
  pendingRequestUrl = null;
  preProcessHtmlCallbacks = [];
  postProcessHtmlCallbacks = [];
  constructor() {
    (super(),
      (this.quantityInput = this.querySelector(".quantity-input")),
      this.postProcessHtmlCallbacks.push((e) => {
        (getQuantityElement(e),
          SidedrawerEventInit(e),
          addMultiplier(e),
          slideshowElements(e),
          customSliderArrowsEvents(e),
          productRecommendations(),
          bundleProductInit(e));
      }));
  }
  connectedCallback() {
    ((this.section = this.closest("section")),
      (this.stickyProductWrapper =
        this.section.querySelector("sticky-addto-cart")),
      (this.onVariantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.optionValueSelectionChange,
        this.handleOptionValueChange.bind(this),
      )),
      this.initQuantityHandlers(),
      this.dispatchEvent(
        new CustomEvent("product-info:loaded", { bubbles: !0 }),
      ),
      this.section &&
        setTimeout(() => {
          aosAnimation && AOS && AOS.refreshHard();
        }, 500));
  }
  initQuantityHandlers() {
    this.quantityInput &&
      ((this.quantityForm = this.querySelector(
        "[data-product-quantity-wrapper]",
      )),
      this.quantityForm &&
        (this.setQuantityBoundries(),
        this.dataset.originalSection ||
          (this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this),
          ))));
  }
  handleOptionValueChange({
    data: { event: e, target: t, selectedOptionValues: o },
  }) {
    if (!this.contains(e.target)) return;
    const r = "sticky-product" === this.sectionId,
      i =
        (window.scrollY,
        t.dataset.productUrl || this.pendingRequestUrl || this.dataset.url);
    this.pendingRequestUrl = i;
    const s = this.dataset.url !== i,
      n = "true" === this.dataset.updateUrl && s;
    this.renderProductInfo({
      requestUrl: this.buildRequestUrlWithParams(i, o, n),
      targetId: t.id,
      callback: (e) => {
        ((s ? this.handleSwapProduct(i, n) : this.handleUpdateProductInfo(i))(
          e,
        ),
          (() => {
            if (r) {
              const e = document.querySelector(
                "[data-sticky-products-wrapper]",
              );
              e && e.classList.add("show");
            }
          })());
      },
    });
  }
  buildRequestUrlWithParams(e, t, o = !1) {
    const r = [];
    return (
      !o && r.push(`section_id=${this.sectionId}`),
      t.length && r.push(`option_values=${t.join(",")}`),
      `${e}?${r.join("&")}`
    );
  }
  handleSwapProduct(e, t) {
    return (o) => {
      this.productModal?.remove();
      const r = t ? "product-info[id^='product-info']" : "product-info",
        i = this.getSelectedVariant(o.querySelector(r));
      (this.updateURL(e, i?.id),
        t
          ? ((document.querySelector("head title").innerHTML =
              o.querySelector("head title").innerHTML),
            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              o.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks,
            ))
          : HTMLUpdateUtility.viewTransition(
              this,
              o.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks,
            ));
    };
  }
  handleUpdateProductInfo(e) {
    return (t) => {
      const o = this.getSelectedVariant(t);
      if (
        (this.stickyAddtoCart(t),
        this.querySelector("[data-pickup-availability]") &&
          this.pickupAvailability(o),
        this.updateOptionValues(t),
        this.updateURL(e, o?.id),
        this.updateVariantInputs(o?.id),
        !o)
      )
        return void this.setUnavailable();
      this.updateMedia(t, o?.featured_media?.id);
      const r = (e, o = (e) => !1) => {
        const r = t.getElementById(`${e}-${this.sectionId}`),
          i = this.querySelector(`#${e}-${this.sectionId}`);
        r &&
          i &&
          ((i.innerHTML = r.innerHTML), i.classList.toggle("hidden", o(r)));
      };
      (r("product-price"),
        r("sticky-block-product-price"),
        r("sku-wrapper", ({ classList: e }) => e.contains("hidden")),
        r("sticky-block-sku-wrapper", ({ classList: e }) =>
          e.contains("hidden"),
        ),
        r("product-inventory-wrapper", ({ innerText: e }) => "" === e),
        r(
          "sticky-block-product-inventory-wrapper",
          ({ innerText: e }) => "" === e,
        ),
        r("Volume"),
        r("Price-Per-Item", ({ classList: e }) => e.contains("hidden")),
        this.updateQuantityRules(this.sectionId, t),
        this.querySelector(
          `#Quantity-Rules-${this.sectionId}`,
        )?.classList.remove("hidden"));
      const i = t.getElementById(
          `ProductSubmitButton-${this.sectionId}-${this.productId}`,
        ),
        s = i?.querySelector("[data-submit-button]")?.textContent?.trim();
      this.productForm?.toggleSubmitButton(
        i?.hasAttribute("disabled") ?? !0,
        s || soldoutATCText,
      );
    };
  }
  stickyAddtoCart(e) {
    if (this.stickyProductWrapper) {
      const t = e.getElementById(
        `sticky-product-info-${this.sectionId}-${this.productId}`,
      );
      if (t) {
        if (this.stickyProductWrapper.classList.contains("sticky-visible")) {
          const e = t.querySelector("[data-sticky-options-btn]"),
            o = t.querySelector("[data-sticky-options]");
          (e && e.classList.add("active"), o && (o.style.display = "block"));
        }
        this.stickyProductWrapper.innerHTML = t.innerHTML;
      }
    }
  }
  pickupAvailability(e) {
    let t = this.closest(".shopify-section"),
      o = this.querySelector("[data-pickup-availability]"),
      r = this.querySelector("[data-pickup-availability-content]"),
      i = t.querySelector("[data-pickup-location-list]");
    if (o)
      if (null != e && 1 == e.available) {
        var s = o.dataset.rootUrl,
          n = e.id;
        (s.endsWith("/") || (s += "/"),
          fetch(`${s}variants/${n}/?section_id=pickup-availability`)
            .then((e) => e.text())
            .then((e) => {
              var s = new DOMParser()
                .parseFromString(e, "text/html")
                .querySelector(".shopify-section");
              let n = s.querySelector("[data-pickup-availability-content]"),
                a = s.querySelector("[data-pickup-location-list]");
              ((r.innerHTML = n ? n.innerHTML : ""),
                i &&
                  ((i.innerHTML = a ? a.innerHTML : ""),
                  i.classList.remove("hidden")),
                "" != n.innerHTML
                  ? (o.setAttribute("available", ""),
                    o.classList.remove("hidden"))
                  : (o.classList.add("hidden"), o.removeAttribute("available")),
                SidedrawerEventInit(t));
            })
            .catch((e) => {}));
      } else
        (o.classList.add("hidden"),
          (r.innerHTML = ""),
          i && (i.innerHTML = ""),
          o.removeAttribute("available"));
  }
  setQuantityBoundries() {
    const e = {
      cartQuantity: this.quantityInput.dataset.cartQuantity
        ? parseInt(this.quantityInput.dataset.cartQuantity)
        : 0,
      min: this.quantityInput.dataset.min
        ? parseInt(this.quantityInput.dataset.min)
        : 1,
      max: this.quantityInput.dataset.max
        ? parseInt(this.quantityInput.dataset.max)
        : null,
      step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
    };
    let t = e.min;
    const o = null === e.max ? e.max : e.max - e.cartQuantity;
    (null !== o && (t = Math.min(t, o)),
      e.cartQuantity >= e.min && (t = Math.min(t, e.step)),
      (this.quantityInput.min = t),
      o
        ? (this.quantityInput.max = o)
        : this.quantityInput.removeAttribute("max"),
      (this.quantityInput.value = t),
      publish(PUB_SUB_EVENTS.quantityUpdate, void 0));
  }
  fetchQuantityRules() {
    const e = this.productForm?.variantIdInput?.value;
    if (e)
      return fetch(
        `${this.dataset.url}?variant=${e}&section_id=${this.dataset.section}`,
      )
        .then((e) => e.text())
        .then((e) => {
          const t = new DOMParser().parseFromString(e, "text/html");
          this.updateQuantityRules(this.dataset.section, t);
        })
        .catch((e) => console.error(e))
        .finally(() => {});
  }
  updateQuantityRules(e, t) {
    if (!this.quantityInput) return;
    this.setQuantityBoundries();
    const o = t.getElementById(`Quantity-Form-${e}-${this.productId}`),
      r = [".quantity-input"];
    for (let e of r) {
      const t = this.quantityForm.querySelector(e),
        r = o.querySelector(e);
      if (t && r)
        if (".quantity-input" === e) {
          const e = ["data-cart-quantity", "data-min", "data-max", "step"];
          for (let o of e) {
            const e = r.getAttribute(o);
            null !== e ? t.setAttribute(o, e) : t.removeAttribute(o);
          }
        } else t.innerHTML = r.innerHTML;
    }
  }
  getSelectedVariant(e) {
    const t = e.querySelector(
      "variant-selects [data-selected-variant]",
    )?.innerHTML;
    return t ? JSON.parse(t) : null;
  }
  updateURL(e, t) {
    (this.querySelector("share-button")?.updateUrl(
      `${window.shopUrl}${e}${t ? `?variant=${t}` : ""}`,
    ),
      "false" !== this.dataset.updateUrl &&
        window.history.replaceState({}, "", `${e}${t ? `?variant=${t}` : ""}`));
  }
  updateMedia(e, t) {
    if (!t) return;
    const o = this.querySelector(`#productmedia-${t}`),
      r = this.querySelector("[data-product-main-media]");
    if (o && r)
      if (r.classList.contains("flickity-enabled")) {
        let e = Array.from(o.parentElement.children).indexOf(o);
        Flickity.data(r).select(e);
      } else {
        let e = r.children.length,
          t = r.firstChild;
        e > 1 && r.insertBefore(o, t);
      }
    if (
      "stacked" ==
      this.querySelector("[data-product-media]").getAttribute("data-type")
    ) {
      let e = this.querySelector(`#productmedia-${t}`),
        o = document.getElementById("showMoreButton");
      e &&
        (e.classList.contains("hidden-media")
          ? (o.click(), e.scrollIntoView({ behavior: "smooth" }))
          : e.scrollIntoView({ behavior: "smooth" }));
    }
  }
  updateVariantInputs(e) {
    this.querySelectorAll(
      `#product-form-${this.sectionId}-${this.productId}, #product-form-installment-product-form-${this.sectionId}-${this.productId}, #sticky-block-product-form-installment-product-form-${this.sectionId}-${this.productId}`,
      "product-form-sticky-product",
    ).forEach((t) => {
      const o = t.querySelector('input[name="id"]');
      ((o.value = e ?? ""),
        o.dispatchEvent(new Event("change", { bubbles: !0 })));
    });
  }
  updateOptionValues(e) {
    const t = e.querySelector("variant-selects");
    t &&
      HTMLUpdateUtility.viewTransition(
        this.variantSelectors,
        t,
        this.preProcessHtmlCallbacks,
      );
  }
  setUnavailable() {
    this.productForm?.toggleSubmitButton(!0, unavailableATCText);
    const e = [
      "sku-wrapper",
      "Price-Per-Item",
      "product-inventory-wrapper",
      "Quantity-Rules",
      "Volume",
    ]
      .map((e) => `#${e}-${this.dataset.section}`)
      .join(", ");
    document.querySelectorAll(e).forEach(({ classList: e }) => e.add("hidden"));
  }
  renderProductInfo({ requestUrl: e, targetId: t, callback: o }) {
    (this.abortController?.abort(),
      (this.abortController = new AbortController()),
      fetch(e, { signal: this.abortController.signal })
        .then((e) => e.text())
        .then((e) => {
          this.pendingRequestUrl = null;
          const t = new DOMParser().parseFromString(e, "text/html");
          o(t);
        })
        .then(() => {})
        .catch((e) => {
          "AbortError" === e.name
            ? console.log("Fetch aborted by user")
            : console.error(e);
        }));
  }
  get productForm() {
    return this.querySelector("product-form");
  }
  get variantSelectors() {
    return this.querySelector("variant-selects");
  }
  get sectionId() {
    return this.dataset.originalSection || this.dataset.section;
  }
  get productId() {
    return this.getAttribute("data-product-id");
  }
}
customElements.define("product-info", ProductInfo);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener("change", (e) => {
      const t = this.getInputForEventTarget(e.target);
      (this.updateSelectionMetadata(e.target),
        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event: e,
            target: t,
            selectedOptionValues: this.selectedOptionValues,
          },
        }),
        this.dispatchEvent(
          new CustomEvent("variant-change", {
            bubbles: !0,
            detail: { selectedOptionValues: this.selectedOptionValues },
          }),
        ));
    });
  }
  updateSelectionMetadata(e) {
    if ("SELECT" === e.tagName && e.selectedOptions.length) {
      const t = Array.from(e.options).find((e) => e.hasAttribute("selected"));
      (t && t.removeAttribute("selected"),
        e.selectedOptions[0].setAttribute("selected", ""));
    }
  }
  getInputForEventTarget(e) {
    return "SELECT" === e.tagName ? e.selectedOptions[0] : e;
  }
  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked"),
    ).map((e) => e.getAttribute("data-option-value-id"));
  }
}
customElements.define("variant-selects", VariantSelects);
class ProductForm extends HTMLElement {
  constructor() {
    (super(),
      (this.section = this.closest("section")),
      (this.form = this.querySelector("form")),
      this.form &&
        (this.variantIdInput && (this.variantIdInput.disabled = !1),
        (this.TermsConditionscheckbox = null),
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
        (this.dataTermsConditions = this.querySelector(
          "[data-terms-conditions]",
        )),
        (this.submitButton = this.querySelector('[type="submit"]')),
        (this.submitButtonText = this.submitButton.querySelector("span")),
        (this.hideErrors = "true" === this.dataset.hideErrors),
        (this.cartDrawer = document.querySelector(
          "#ajax-cart-drawer[data-side-drawer]",
        ))));
  }
  connectedCallback() {
    this.dataTermsConditions &&
      ((this.TermsConditionscheckbox = this.dataTermsConditions.querySelector(
        'input[type="checkbox"]',
      )),
      this.TermsConditionscheckbox &&
        this.TermsConditionscheckbox.addEventListener(
          "change",
          this.handleCheckboxChange.bind(this),
        ));
  }
  disconnectedCallback() {
    this.TermsConditionscheckbox &&
      this.TermsConditionscheckbox.removeEventListener(
        "change",
        this.handleCheckboxChange.bind(this),
      );
  }
  handleCheckboxChange(e) {
    e.target.checked
      ? this.submitButton.classList.remove("disabled-button")
      : this.submitButton.classList.add("disabled-button");
  }
  onSubmitHandler(e) {
    (e.preventDefault(), this.handleErrorMessage());
    let t = "ajax-cart-drawer",
      o = "";
    var r = window.location.pathname;
    if (r.indexOf("/cart") > -1) {
      let e = document.querySelector("[data-cart-wrapper]");
      ((o = e), e && (t = e.dataset.section));
    }
    const i = fetchConfig("javascript");
    ((i.headers["X-Requested-With"] = "XMLHttpRequest"),
      delete i.headers["Content-Type"]);
    const s = new FormData(this.form);
    (s.append("sections", [t]),
      (i.body = s),
      fetch(cartAddUrl, i)
        .then((e) => e.json())
        .then((e) => {
          if ((console.log(e), e.status))
            return (
              console.log(e.status),
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: s.get("id"),
                errors: e.errors || e.description,
                message: e.message,
              }),
              this.handleErrorMessage(e.description),
              void (this.error = !0)
            );
          if ("page" == carType) return ((window.location.href = "/cart"), !1);
          if (
            (shakeEffect &&
              (this.submitButton.classList.add("shake"),
              setTimeout(() => {
                this.submitButton.classList.remove("shake");
              }, 700)),
            this.error ||
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: s.get("id"),
                cartData: e,
              }),
            (this.error = !1),
            hapticFeedbackStatus)
          ) {
            window.navigator.vibrate && window.navigator.vibrate(500);
          }
          if (
            (document.getElementById("cartAlert") &&
              document.getElementById("cartAlert").play(),
            r.indexOf("/cart") > -1)
          ) {
            let r = new DOMParser()
                .parseFromString(e.sections[t], "text/html")
                .querySelector(".shopify-section")
                .querySelector("[data-cart-wrapper]"),
              s = parseInt(r.getAttribute("data-item-count"));
            (cartCountUpdate(s),
              (o.innerHTML = r.innerHTML),
              element.removeAttribute("disabled"),
              setTimeout(() => {
                s > 0 &&
                  (getQuantityElement(o),
                  cartNoteUpdate(o),
                  getCartItemRemoveElements(o),
                  cartGiftWrapElement(o),
                  cartTotalprice(o),
                  shippingEstimates());
              }, 500));
            var i = o.offsetTop;
            window.scrollTo({ top: i, behavior: "smooth" });
          } else {
            let o,
              r = new DOMParser()
                .parseFromString(e.sections[t], "text/html")
                .querySelector(".shopify-section"),
              i = r.innerHTML,
              s = document.querySelector("[data-cart-drwaer-body]"),
              n = 0;
            (r.querySelector("[data-cart-wrapper]") &&
              ((n = parseInt(
                r
                  .querySelector("[data-cart-wrapper]")
                  .getAttribute("data-item-count"),
              )),
              (o = r
                .querySelector("[data-cart-wrapper]")
                .getAttribute("data-item-total"))),
              (s.innerHTML = i),
              n > 0 && getQuantityElement(s),
              cartCountUpdate(n),
              cartNoteUpdate(),
              getCartItemRemoveElements(this.cartDrawer),
              cartGiftWrapElement(this.cartDrawer),
              cartTermhandlerClick(),
              cartTermsHandler(),
              setTimeout(function () {
                this.cartDrawer = document.querySelector(".cart-drawer");
                let e = document.querySelector(".quickview-drawer"),
                  t = document.querySelector("[data-compare-model]");
                (e &&
                  (e.classList.remove("sidebar-visible"),
                  setTimeout(function () {
                    e.style.display = "none";
                  }, 300)),
                  t &&
                    this.cartDrawer.classList.contains("sidebar-visible") &&
                    t.querySelector(".compare-modal-content") &&
                    t
                      .querySelector(".compare-modal-content")
                      .classList.remove("popup-visible"));
              }, 100),
              setTimeout(function () {
                (this.cartDrawer &&
                  this.cartDrawer.classList.add("sidebar-visible"),
                  setTimeout(function () {
                    (focusElementsRotation(this.cartDrawer),
                      (previousFocusElement = this.submitButton));
                  }, 500));
              }, 500));
            let a = this.cartDrawer.querySelector(
              "[data-recommendation-popup]",
            );
            (a &&
              !a.classList.contains("active") &&
              (setTimeout(() => {
                a.classList.add("active");
              }, 1e3),
              slideshowElements()),
              (this.cartDrawer.style.display = "flex"),
              document.querySelector("body").classList.add("no-scroll"),
              this.submitButton.removeAttribute("disabled"));
          }
          document.querySelector("[data-cart-shipping]") &&
            "100%" ==
              document
                .querySelector("[data-cart-shipping]")
                .getAttribute("data-barwidth") &&
            (!document.querySelector(".confetti-container-wrapper") ||
              ("false" != localStorage.confettiEffect &&
                null != localStorage.confettiEffect) ||
              ((window.confettiful = new Confettiful(
                document.querySelector(".confetti-container-wrapper"),
              )),
              (localStorage.confettiEffect = "true"),
              setTimeout(function () {
                clearInterval(confettiInterval);
              }, 3e3)));
        })
        .finally(() => {}));
  }
  handleErrorMessage(e = !1) {
    ((this.errorMessageWrapper = this.querySelector("[data-form-error]")),
      this.errorMessageWrapper &&
        (this.errorMessageWrapper && 0 != e
          ? ((this.errorMessageWrapper.textContent = e),
            (this.errorMessageWrapper.style.display = "block"),
            this.errorMessageWrapper.classList.remove("hidden"))
          : ((this.errorMessageWrapper.style.display = "none"),
            this.errorMessageWrapper.classList.add("hidden"))));
  }
  toggleSubmitButton(e = !1, t, o = !1, r) {
    if (!this.submitButton) return;
    (this.submitButton.removeAttribute("loading"),
      this.submitButton.removeAttribute("unavailable"));
    const i = this.submitButton.querySelector("[data-submit-button]");
    this.submitButton.querySelector("[data-submit-button] span");
    if (e)
      (this.dataTermsConditions &&
        (this.dataTermsConditions.style.display = "none"),
        this.submitButton.setAttribute("disabled", ""),
        o && this.submitButton.setAttribute("unavailable", ""),
        t && i
          ? (i.textContent = t)
          : this.submitButton.setAttribute("loading", ""));
    else if (
      (this.dataTermsConditions &&
        (this.dataTermsConditions.style.display = "block"),
      this.submitButton.removeAttribute("disabled"),
      i)
    ) {
      const e =
        "true" === this.submitButton.getAttribute("data-pre-order")
          ? preorderATCText
          : availableATCText;
      i.textContent = t || e;
    }
  }
  get variantIdInput() {
    return this.querySelector('[name="id"]');
  }
}
function roundToTwo(e) {
  return +(Math.round(e + "e+2") + "e-2");
}
customElements.define("product-form", ProductForm);
const getMousePos = (e) => {
  var t = e.currentTarget.getBoundingClientRect();
  return { x: e.clientX - t.left, y: e.clientY - t.top };
};
function debounce(e, t = 300) {
  let o;
  return (...r) => {
    (clearTimeout(o), (o = setTimeout(() => e.apply(this, r), t)));
  };
}
((Shopify.bind = function (e, t) {
  return function () {
    return e.apply(t, arguments);
  };
}),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var o = 0, r = e.options.length; o < r; o++) {
      var i = e.options[o];
      if (t == i.value || t == i.innerHTML) return ((e.selectedIndex = o), o);
    }
  }),
  (Shopify.addListener = function (e, t, o) {
    e.addEventListener
      ? e.addEventListener(t, o, !1)
      : e.attachEvent("on" + t, o);
  }),
  (Shopify.postLink = function (e, t) {
    var o = (t = t || {}).method || "post",
      r = t.parameters || {},
      i = document.createElement("form");
    for (var s in (i.setAttribute("method", o),
    i.setAttribute("action", e),
    r)) {
      var n = document.createElement("input");
      (n.setAttribute("type", "hidden"),
        n.setAttribute("name", s),
        n.setAttribute("value", r[s]),
        i.appendChild(n));
    }
    (document.body.appendChild(i), i.submit(), document.body.removeChild(i));
  }),
  (Shopify.CountryProvinceSelector = function (e, t, o) {
    ((this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(o.hideElement || t)),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this),
      ),
      this.initCountry(),
      this.initProvince());
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute("data-default");
      (Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler());
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute("data-default");
      e &&
        this.provinceEl.options.length > 0 &&
        Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
      var t = (i =
          this.countryEl.options[this.countryEl.selectedIndex]).getAttribute(
          "data-provinces",
        ),
        o = JSON.parse(t);
      if ((this.clearOptions(this.provinceEl), o && 0 == o.length))
        this.provinceContainer.style.display = "none";
      else {
        for (var r = 0; r < o.length; r++) {
          var i;
          (((i = document.createElement("option")).value = o[r][0]),
            (i.innerHTML = o[r][1]),
            this.provinceEl.appendChild(i));
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (e) {
      for (; e.firstChild; ) e.removeChild(e.firstChild);
    },
    setOptions: function (e, t) {
      var o = 0;
      for (t.length; o < t.length; o++) {
        var r = document.createElement("option");
        ((r.value = t[o]), (r.innerHTML = t[o]), e.appendChild(r));
      }
    },
  }));
const addressSelectors = {
    customerAddresses: "body",
    addressCountrySelect: "[data-address-country]",
    addressContainer: "[data-address]",
    toggleAddressButton: "button[aria-expanded]",
    cancelAddressButton: 'button[type="reset"]',
    deleteAddressButton: "button[data-confirm-message]",
  },
  attributes = {
    expanded: "aria-expanded",
    confirmMessage: "data-confirm-message",
  };
class CustomerAddresses {
  constructor() {
    ((this.elements = this._getElements()),
      0 !== Object.keys(this.elements).length &&
        (this._setupCountries(), this._setupEventListeners()));
  }
  _getElements() {
    const e = document.querySelector(addressSelectors.customerAddresses);
    return e
      ? {
          container: e,
          addressContainer: e.querySelector(addressSelectors.addressContainer),
          toggleButtons: document.querySelectorAll(
            addressSelectors.toggleAddressButton,
          ),
          deleteButtons: e.querySelectorAll(
            addressSelectors.deleteAddressButton,
          ),
          countrySelects: e.querySelectorAll(
            addressSelectors.addressCountrySelect,
          ),
        }
      : {};
  }
  _setupCountries() {
    Shopify &&
      Shopify.CountryProvinceSelector &&
      (new Shopify.CountryProvinceSelector(
        "AddressCountry_new",
        "AddressProvince_new",
        { hideElement: "AddressProvinceContainer_new" },
      ),
      this.elements.countrySelects.forEach((e) => {
        const t = e.dataset.formId;
        new Shopify.CountryProvinceSelector(
          `AddressCountry_${t}`,
          `AddressProvince_${t}`,
          { hideElement: `AddressProvinceContainer_${t}` },
        );
      }));
  }
  _setupEventListeners() {
    (this.elements.toggleButtons.forEach((e) => {
      e.addEventListener("click", this._handleAddEditButtonClick);
    }),
      this.elements.deleteButtons.forEach((e) => {
        e.addEventListener("click", this._handleDeleteButtonClick);
      }));
  }
  _toggleExpanded(e) {
    ((this.elements = this._getElements()),
      this._setupCountries(),
      this._setupEventListeners());
  }
  _handleAddEditButtonClick = ({ currentTarget: e }) => {
    this._toggleExpanded(e);
  };
  _handleDeleteButtonClick = ({ currentTarget: e }) => {
    confirm(e.getAttribute(attributes.confirmMessage)) &&
      Shopify.postLink(e.dataset.target, { parameters: { _method: "delete" } });
  };
}
class ShapeOverlays {
  constructor(e) {
    ((this.elm = e),
      (this.path = e.querySelectorAll("path")),
      (this.numPoints = 2),
      (this.duration = 600),
      (this.delayPointsArray = []),
      (this.delayPointsMax = 0),
      (this.delayPerPath = 200),
      (this.timeStart = Date.now()),
      (this.isOpened = !1),
      (this.isAnimating = !1));
  }
  toggle() {
    this.isAnimating = !0;
    for (var e = 0; e < this.numPoints; e++) this.delayPointsArray[e] = 0;
    !1 === this.isOpened ? this.open() : this.close();
  }
  open() {
    ((this.isOpened = !0),
      this.elm.classList.add("is-opened"),
      (this.timeStart = Date.now()),
      this.renderLoop());
  }
  close() {
    ((this.isOpened = !1),
      this.elm.classList.remove("is-opened"),
      (this.timeStart = Date.now()),
      this.renderLoop());
  }
  updatePath(e) {
    const t = [];
    for (var o = 0; o < this.numPoints; o++) {
      const r = this.isOpened
        ? 1 == o
          ? ease.cubicOut
          : ease.cubicInOut
        : 1 == o
          ? ease.cubicInOut
          : ease.cubicOut;
      t[o] =
        100 *
        r(
          Math.min(
            Math.max(e - this.delayPointsArray[o], 0) / this.duration,
            1,
          ),
        );
    }
    let r = "";
    r += this.isOpened ? `M 0 0 V ${t[0]} ` : `M 0 ${t[0]} `;
    for (o = 0; o < this.numPoints - 1; o++) {
      const e = ((o + 1) / (this.numPoints - 1)) * 100,
        i = e - ((1 / (this.numPoints - 1)) * 100) / 2;
      r += `C ${i} ${t[o]} ${i} ${t[o + 1]} ${e} ${t[o + 1]} `;
    }
    return ((r += this.isOpened ? "V 0 H 0" : "V 100 H 0"), r);
  }
  render() {
    if (this.isOpened)
      for (var e = 0; e < this.path.length; e++)
        this.path[e].setAttribute(
          "d",
          this.updatePath(
            Date.now() - (this.timeStart + this.delayPerPath * e),
          ),
        );
    else
      for (e = 0; e < this.path.length; e++)
        this.path[e].setAttribute(
          "d",
          this.updatePath(
            Date.now() -
              (this.timeStart + this.delayPerPath * (this.path.length - e - 1)),
          ),
        );
  }
  renderLoop() {
    (this.render(),
      Date.now() - this.timeStart <
      this.duration +
        this.delayPerPath * (this.path.length - 1) +
        this.delayPointsMax
        ? requestAnimationFrame(() => {
            this.renderLoop();
          })
        : (this.isAnimating = !1));
  }
}
function openCloseAddressDetails(e) {
  e.preventDefault();
  let t = e.target;
  if (
    t.classList.contains("add-address") ||
    t.classList.contains("edit-text")
  ) {
    let e = document.querySelector(".add-address-wrapper.active");
    e &&
      (e.classList.add("hidden"),
      e.classList.remove("active"),
      e.querySelector("form") && e.querySelector("form").reset());
    let o = t.getAttribute("href");
    document.querySelector(o) &&
      (document.querySelector(o).classList.remove("hidden"),
      document.querySelector(o).classList.add("active"),
      setTimeout(() => {
        document.querySelector(o).scrollIntoView({ behavior: "smooth" });
      }, 200));
  } else {
    let e = t.getAttribute("href");
    document.querySelector(e) &&
      (document.querySelector(e).scrollIntoView({ behavior: "smooth" }),
      setTimeout(() => {
        (t.closest(".add-address-wrapper").classList.add("hidden"),
          document.querySelector(e).classList.remove("active"),
          t.closest(".add-address-wrapper").querySelector("form") &&
            t.closest(".add-address-wrapper").querySelector("form").reset());
      }, 200));
  }
}
var DOMAnimations = {
  slideUp: function (e, t = 500) {
    return new Promise(function (o, r) {
      ((e.style.height = e.offsetHeight + "px"),
        (e.style.transitionProperty = "height, margin, padding"),
        (e.style.transitionDuration = t + "ms"),
        e.offsetHeight,
        (e.style.overflow = "hidden"),
        (e.style.height = 0),
        (e.style.paddingTop = 0),
        (e.style.paddingBottom = 0),
        (e.style.marginTop = 0),
        (e.style.marginBottom = 0),
        window.setTimeout(function () {
          ((e.style.display = "none"),
            e.style.removeProperty("height"),
            e.style.removeProperty("padding-top"),
            e.style.removeProperty("padding-bottom"),
            e.style.removeProperty("margin-top"),
            e.style.removeProperty("margin-bottom"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property"),
            o(!1));
        }, t));
    });
  },
  slideDown: function (e, t = 500) {
    return new Promise(function (o, r) {
      e.style.removeProperty("display");
      let i = window.getComputedStyle(e).display;
      ("none" === i && (i = "block"), (e.style.display = i));
      let s = e.offsetHeight;
      ((e.style.overflow = "hidden"),
        (e.style.height = 0),
        (e.style.paddingTop = 0),
        (e.style.paddingBottom = 0),
        (e.style.marginTop = 0),
        (e.style.marginBottom = 0),
        e.offsetHeight,
        (e.style.transitionProperty = "height, margin, padding"),
        (e.style.transitionDuration = t + "ms"),
        (e.style.height = s + "px"),
        e.style.removeProperty("padding-top"),
        e.style.removeProperty("padding-bottom"),
        e.style.removeProperty("margin-top"),
        e.style.removeProperty("margin-bottom"),
        window.setTimeout(function () {
          (e.style.removeProperty("height"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property"));
        }, t));
    });
  },
  slideToggle: function (e, t = 500) {
    return (
      console.log(e),
      "none" === window.getComputedStyle(e).display
        ? this.slideDown(e, t)
        : this.slideUp(e, t)
    );
  },
  classToggle: function (e, t) {
    e.classList.contains(t) ? e.classList.remove(t) : e.classList.add(t);
  },
};
function showTab(e, t) {
  var o, r, i;
  for (
    r = document.getElementsByClassName("tab-content"), o = 0;
    o < r.length;
    o++
  )
    r[o].style.display = "none";
  for (
    i = document.getElementsByClassName("tab-button"), o = 0;
    o < i.length;
    o++
  )
    i[o].classList.remove("active");
  ((document.getElementById(t).style.display = "block"),
    e.currentTarget.classList.add("active"));
}
function setCookie(e, t, o) {
  const r = new Date();
  r.setTime(r.getTime() + 24 * o * 60 * 60 * 1e3);
  let i = "expires=" + r.toUTCString();
  document.cookie = e + "=" + t + ";" + i + ";path=/";
}
function getCookie(e) {
  let t = e + "=",
    o = decodeURIComponent(document.cookie).split(";");
  for (let e = 0; e < o.length; e++) {
    let r = o[e];
    for (; " " == r.charAt(0); ) r = r.substring(1);
    if (0 == r.indexOf(t)) return r.substring(t.length, r.length);
  }
  return "";
}
function isOnScreen(e, t) {
  if (e) {
    if (0 == e.length) return;
    var o = $(window),
      r = o.scrollTop(),
      i = o.height(),
      s = r + i,
      n = $(e),
      a = n.offset().top;
    t && (a += t);
    var c = n.height(),
      l = a + c;
    return (
      (a >= r && a < s) || (l > r && l <= s) || (c > i && a <= r && l >= s)
    );
  }
}
function focusableElements(e) {
  if (!e) return !1;
  return Array.from(
    e.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
(Element.prototype.fadeIn ||
  (Element.prototype.fadeIn = function () {
    let e = isNaN(arguments[0]) ? 400 : arguments[0],
      t =
        "function" == typeof arguments[0]
          ? arguments[0]
          : "function" == typeof arguments[1]
            ? arguments[1]
            : null;
    ((this.style.opacity = 0),
      (this.style.filter = "alpha(opacity=0)"),
      (this.style.display = "inline-block"),
      (this.style.visibility = "visible"));
    let o = this,
      r = 0,
      i = setInterval(function () {
        ((r += 50 / e),
          r >= 1 && (clearInterval(i), (r = 1), t && t("done!")),
          (o.style.opacity = r),
          (o.style.filter = "alpha(opacity=" + 100 * r + ")"));
      }, 50);
  }),
  Element.prototype.fadeOut ||
    (Element.prototype.fadeOut = function () {
      let e = isNaN(arguments[0]) ? 400 : arguments[0],
        t =
          "function" == typeof arguments[0]
            ? arguments[0]
            : "function" == typeof arguments[1]
              ? arguments[1]
              : null,
        o = this,
        r = 1,
        i = setInterval(function () {
          ((r -= 50 / e),
            r <= 0 &&
              (clearInterval(i),
              (r = 0),
              (o.style.display = "none"),
              (o.style.visibility = "hidden"),
              t && t("done!")),
            (o.style.opacity = r),
            (o.style.filter = "alpha(opacity=" + 100 * r + ")"));
        }, 50);
    }));
const listFocusElements = {};
var searchTyping,
  previousFocusElement = "";
function focusElementsRotation(e) {
  stopFocusRotation();
  let t = focusableElements(e);
  if (0 == t) return !1;
  let o = t[0];
  o.focus();
  let r = t[t.length - 1];
  ((listFocusElements.focusin = (t) => {
    (t.target !== e && t.target !== r && t.target !== o) ||
      document.addEventListener("keydown", listFocusElements.keydown);
  }),
    (listFocusElements.focusout = function () {
      document.removeEventListener("keydown", listFocusElements.keydown);
    }),
    (listFocusElements.keydown = function (t) {
      "TAB" === t.code.toUpperCase() &&
        (t.target !== r || t.shiftKey || (t.preventDefault(), o.focus()),
        (t.target !== e[0] && t.target !== o) ||
          !t.shiftKey ||
          (t.preventDefault(), r.focus()));
    }),
    document.addEventListener("focusout", listFocusElements.focusout),
    document.addEventListener("focusin", listFocusElements.focusin));
}
function stopFocusRotation() {
  (document.removeEventListener("focusin", listFocusElements.focusin),
    document.removeEventListener("focusout", listFocusElements.focusout),
    document.removeEventListener("keydown", listFocusElements.keydown));
}
function playButtonClickEvent(e) {
  if (e.closest("[data-video-main-wrapper]")) {
    let t = e.closest("[data-video-main-wrapper]"),
      o = t.querySelector("video"),
      r = t.querySelector("iframe");
    e.addEventListener("click", function (i) {
      (i.preventDefault(), (e.style.display = "none"));
      let s = t.querySelector(".video-content-wrapper"),
        n = t.querySelector(".video-title");
      ((t.querySelector(".video-thumbnail").style.display = "none"),
        s && (s.style.display = "none"),
        n && (n.style.display = "none"),
        o
          ? ((o.style.display = "block"), o.play())
          : (r.style.display = "block"));
    });
  }
}
function videoPlayInit() {
  if (document.querySelectorAll("[data-video-play-button]")) {
    let e = document.querySelectorAll("[data-video-play-button]");
    Array.from(e).forEach(function (e) {
      e && playButtonClickEvent(e);
    });
  }
}
function slideshowElements(e = document) {
  let t = e.querySelectorAll("[data-slideshow]");
  Array.from(t).forEach(function (e) {
    try {
      slideshowInit(e);
    } catch (err) {
      console.error(err);
    }
  });
}
function slideshowInit(e) {
  if (!e || typeof Flickity === "undefined") return;
  if (e.classList.contains("flickity-enabled")) return;
  if (e.classList.contains("product-media-popup-slider")) {
    let t = e.closest("#product-fetured-media-popup");
    if (
      t &&
      !t.classList.contains("popup-visible") &&
      t.style.display !== "flex"
    )
      return;
  }
  let t;
  try {
    t = JSON.parse(e.getAttribute("data-slideshow") || e.dataset.slideshow || "");
  } catch (err) {
    return;
  }
  if (t) {
    if (e.classList.contains("slideshow-outer")) {
      t.pauseAutoPlayOnHover = !1;
      if (!t.autoPlay) t.autoPlay = 5e3;
      t.wrapAround = !0;
    }
    let o = new Flickity(e, t);
    t.autoPlay && "function" == typeof o.playPlayer && o.playPlayer();
    if (
      document.querySelector("[data-nav-slideshow]") &&
      document
        .querySelector("[data-nav-slideshow]")
        .classList.contains("slideshow-nav-images")
    ) {
      let e = document.querySelectorAll(".slideshow-thumbnail");
      e &&
        e.forEach(function (e) {
          e.style.transition = "0.5s ease";
        });
    }
    if (
      (setTimeout(() => {
        if (
          (o.selectedElements.length >= o.cells.length
            ? (e.classList.add("disable-arrows"),
              (o.options.draggable = !1),
              o.updateDraggable())
            : ((o.options.draggable = !0),
              o.updateDraggable(),
              e.classList.remove("disable-arrows")),
          null == o.options.wrapAround || 0 == o.options.wrapAround)
        ) {
          let t = o.slides.length - 1,
            r = o.selectedIndex;
          (0 == r
            ? e.classList.add("left-arrow-disabled")
            : e.classList.remove("left-arrow-disabled"),
            r == t
              ? e.classList.add("right-arrow-disabled")
              : e.classList.remove("right-arrow-disabled"));
        }
        o.resize();
        o.options.autoPlay &&
          "function" == typeof o.playPlayer &&
          o.playPlayer();
      }, 500),
      e.classList.contains("product-media-popup-slider"))
    ) {
      const e = document.querySelector("media-lightbox-viewer");
      e && "function" == typeof e.swiperSlide && e.swiperSlide();
    }
    if (e.classList.contains("product-grid-wrapper")) {
      const t = e.querySelector(".flickity-viewport"),
        o = e.querySelector(".flickity-slider"),
        r = document.createElement("div");
      (r.classList.add("flickity-slider--wrapper"),
        t.appendChild(r),
        r.appendChild(o));
    }
    o.on("change", function (t) {
      if (
        (null != o.options.autoPlay &&
          0 != o.options.autoPlay &&
          (o.stopPlayer(), o.playPlayer()),
        null == o.options.wrapAround || 0 == o.options.wrapAround)
      ) {
        let t = o.slides.length - 1,
          r = o.selectedIndex;
        (0 == r
          ? e.classList.add("left-arrow-disabled")
          : e.classList.remove("left-arrow-disabled"),
          r == t
            ? e.classList.add("right-arrow-disabled")
            : e.classList.remove("right-arrow-disabled"));
      }
      if (e.hasAttribute("data-slideshow-pagination")) {
        updateSliderPagination(o, e);
        let r = o.element.closest(".shopify-section");
        if (r) {
          let e = r.querySelector(".spotlight-product-item.active"),
            o = r.querySelectorAll(".spotlight-product-item")[t];
          e && o && (e.classList.remove("active"), o.classList.add("active"));
        }
      }
      if (e.classList.contains("announcement-bar-wrapper")) {
        let e = document.querySelectorAll(".announcement-dropdown"),
          t = document.querySelectorAll(".announcement-bar-box");
        (e &&
          document
            .querySelector("body")
            .classList.contains("announcement-open") &&
          (document.querySelector("body").classList.remove("announcement-open"),
          document.querySelector("body").classList.remove("no-scroll"),
          Array.from(e).forEach(function (e) {
            e.classList.remove("show");
          })),
          t &&
            Array.from(t).forEach(function (e) {
              e.querySelector(".announcement-btn") &&
                e.querySelector(".announcement-btn").classList.remove("active");
            }));
      }
      if (e.classList.contains("product-media-popup-slider")) {
        const e = document.querySelector("media-lightbox-viewer");
        e && "function" == typeof e.zoomOut && e.zoomOut();
      }
      if (e.classList.contains("product-gallery-img-slider")) {
        let t = e.querySelector(".sr-product-model-item.is-selected");
        t &&
          setTimeout(function () {
            let e = t.querySelector("model-viewer");
            if (e)
              if (e.classList.contains("shopify-model-viewer-ui__disabled")) {
                let e = t.querySelector(
                  ".shopify-model-viewer-ui__button--poster",
                );
                e && e.removeAttribute("hidden");
                let o = t.querySelector(
                  ".shopify-model-viewer-ui__controls-area--playing",
                );
                o &&
                  o.classList.remove(
                    "shopify-model-viewer-ui__controls-area--playing",
                  );
              } else ((o.options.draggable = !1), o.updateDraggable());
          }, 500);
      }
      closeVideoMedia(e, !1);
    });
  }
}
function updateSliderPagination(e, t) {
  if (t.querySelector(".slider-pagination")) {
    let o = e.selectedIndex + 1,
      r = e.cells.length,
      i = t.querySelector(".current-slide");
    i && (i.innerHTML = o);
    let s = t.querySelector(".total-slides");
    s && (s.innerHTML = r);
  }
}
function customSliderArrowsEvents(e = document) {
  if (typeof Flickity === "undefined") return;
  let t = e.querySelectorAll("[data-slideshow-navigation-button]");
  Array.from(t).forEach(function (e) {
    let t = e.closest("[data-slideshow]"),
      o = t && Flickity.data(t);
    o &&
      e.addEventListener("click", function (t) {
        (t.preventDefault(),
          e.classList.contains("previous") ? o.previous() : o.next());
      });
  });
}
function menuDropdown() {
  let e = document.querySelector(".navbar-block");
  if (e) {
    let t = e.getElementsByClassName("nav-item-on-hover"),
      o = e.querySelectorAll(".nav-item-on-click.dropdown");
    (Array.from(t).forEach(function (t) {
      (t.addEventListener("mouseover", function () {
        document.querySelector("body").classList.add("scroll-none");
        let o = e.querySelector(".nav-item-on-hover.active");
        (o && o.classList.remove("active"), t.classList.add("active"));
      }),
        t.addEventListener("mouseout", function () {
          (document.querySelector("body").classList.remove("scroll-none"),
            t.classList.remove("active"));
        }));
    }),
      Array.from(o).forEach(function (t) {
        t.addEventListener("click", function (o) {
          (o.preventDefault(),
            document.querySelector("body").classList.add("scroll-none"));
          let r = e.querySelectorAll(".nav-item-on-click.active");
          (t.classList.add("active"),
            Array.from(r).forEach(function (e) {
              e.classList.contains("active") && e.classList.remove("active");
            }));
        });
      }));
  }
}
function search_drawer(e = document) {
  let t = e.querySelectorAll("[data-search-open]");
  t &&
    Array.from(t).forEach(function (e) {
      (e.addEventListener("click", (t) => {
        (t.preventDefault(), t.stopPropagation());
        var o = document.querySelector(
          '[data-search-drawer][data-fullwidth="true"]',
        );
        let r = e.closest("[data-search-parent]");
        o &&
          (o.classList.contains("active")
            ? (o.classList.add("hidden"),
              o.classList.remove("active"),
              document
                .querySelector("body")
                .classList.remove("no-scroll", "search-drawer-open"),
              stopFocusRotation(),
              previousFocusElement.focus(),
              (previousFocusElement = ""))
            : (o.classList.add("active"),
              o.classList.remove("hidden"),
              document
                .querySelector("body")
                .classList.add("no-scroll", "search-drawer-open"),
              (previousFocusElement = e),
              focusElementsRotation(o),
              setTimeout(() => {
                o.querySelector("[data-search-input]").focus();
              }, 100)),
          __searchResult(
            (o.querySelector("[data-search-input]").value = ""),
            r,
          ));
      }),
        e.addEventListener("keydown", (e) => {
          document.querySelector("body").classList.add("tab-focus");
        }));
    });
  let o = e.querySelectorAll("[data-search-input]");
  Array.from(o).forEach(function (e) {
    let t = e.closest("[data-search-parent]");
    e.closest("form");
    (e.addEventListener("keydown", (e) => {
      if ("Enter" === e.key) return !0;
    }),
      e.addEventListener("keyup", (e) => {
        if ("Enter" === e.key) return !0;
        (e.preventDefault(),
          clearTimeout(searchTyping),
          (searchTyping = setTimeout(function () {
            if (t) {
              let e = t.querySelector("[data-search-input]").value;
              __searchResult(e, t);
            }
          }, 1e3)));
      }),
      e.addEventListener("click", (e) => {
        let t = document.querySelector("[data-search-drawer]");
        if (t) {
          let e = t.getAttribute("data-header"),
            o = t.getAttribute("data-suggestionStatus");
          "logo_with_search_bar" == e &&
            "true" == o &&
            t.classList.remove("hidden");
        }
      }),
      e.addEventListener("search", (e) => {
        (e.preventDefault(),
          clearTimeout(searchTyping),
          t && __searchResult("", t));
      }));
  });
  let r = e.querySelectorAll("[data-search-reset]");
  Array.from(r).forEach(function (e) {
    e.addEventListener("click", (t) => {
      (t.preventDefault(),
        clearTimeout(searchTyping),
        (e.closest("form").querySelector("[data-search-input]").value = ""),
        setTimeout(function () {
          e.closest("form").querySelector("[data-search-input]").focus();
          let t = e.closest("[data-search-parent]"),
            o = t.querySelector("[data-search-input]").value;
          __searchResult(o, t);
        }, 300));
    });
  });
  let i = e.querySelectorAll("[data-speech-search]");
  Array.from(i).forEach(function (e) {
    initSpeectRecognition(e);
  });
  let s = e.querySelectorAll(
    "[data-search-form], form.predictive-search, form.search",
  );
  Array.from(s).forEach(function (e) {
    (e.setAttribute("action", "/search"), (e.action = "/search"));
    let t = function (t) {
      (t.preventDefault(), t.stopPropagation(), t.stopImmediatePropagation());
      let o = e.querySelector('[name="q"], [data-search-input]'),
        r = "";
      o && (r = o.value.trim());
      let i = e.querySelector('input[name="type"]'),
        s = "product,collection";
      i && (s = i.value);
      let n = "/search?q=" + encodeURIComponent(r);
      return (
        s && (n += "&type=" + encodeURIComponent(s)),
        (window.location.href = n),
        !1
      );
    };
    (e.removeEventListener("submit", t, !0),
      e.addEventListener("submit", t, !0));
  });
}
document.addEventListener("keydown", function (e) {
  if (27 == e.keyCode) {
    document.querySelectorAll("[data-side-drawer]");
  }
});
var __searchResult = function (e, t) {
  if (t) {
    let i = t.querySelector("[data-result-container]"),
      s = t.querySelector("[data-suggestions-container]");
    var o = document.querySelector(
      '[data-search-drawer][data-fullwidth="true"]',
    );
    if (
      "logo_with_search_bar" ==
      i.closest("[data-search-drawer]").getAttribute("data-header")
    )
      if (window.innerWidth >= 768) var r = "fullwidth";
      else r = "drawer";
    else r = o ? "fullwidth" : "drawer";
    if (i) {
      let t = i.closest("[data-search-drawer]"),
        o = t.getAttribute("data-header"),
        n = t.getAttribute("data-suggestionStatus");
      e.replace(/\s/g, "").length > 0
        ? ("logo_with_search_bar" == o &&
            "false" == n &&
            t.classList.remove("hidden"),
          s && s.classList.add("hidden"),
          i.classList.remove("hidden"),
          (i.innerHTML = preLoadLoadGif),
          fetch(
            mainSearchUrl +
              "/suggest?section_id=predictive-search&q=" +
              encodeURIComponent(e) +
              "&resources[type]=" +
              predictiveSearchTypes +
              "&resources[limit]=10&resources[limit_scope]=each&resources[style]=" +
              r,
          )
            .then((e) => e.text())
            .then((e) => {
              let t = new DOMParser().parseFromString(e, "text/html");
              if ("drawer" == r) {
                t.querySelectorAll(
                  ".predictive-search-tranding-products",
                ).forEach((e) => {
                  e.classList.add("product-vertical");
                });
              }
              i.innerHTML = t.querySelector(
                "#shopify-section-predictive-search",
              ).innerHTML;
            }))
        : (s && s.classList.remove("hidden"),
          "logo_with_search_bar" == o &&
            "false" == n &&
            window.innerWidth >= 768 &&
            t.classList.add("hidden"),
          i.classList.add("hidden"),
          (i.innerHTML = ""));
    }
  }
};
function initSpeectRecognition(e) {
  let t = null,
    o = !1,
    r = null;
  const i = window.navigator.userAgent.toLowerCase();
  "webkitSpeechRecognition" in window &&
    i.indexOf("chrome") > -1 &&
    window.chrome &&
    -1 === i.indexOf("edg/") &&
    (e.classList.remove("hidden"),
    (t = new window.webkitSpeechRecognition()),
    (t.continuous = !1),
    (t.interimResults = !1),
    (r = e.closest("form").querySelector("[data-search-input]")),
    t.addEventListener(
      "result",
      debounce((e) => {
        if (e.results) {
          const t = e.results[0][0].transcript;
          ((r.value = t), r.focus(), r.dispatchEvent(new Event("input")));
          let o = r.closest("[data-search-parent]");
          __searchResult(t, o);
        }
      }, 300),
    ),
    t.addEventListener("audiostart", () => {
      ((o = !0), e.classList.add("active"));
    }),
    t.addEventListener("audioend", () => {
      ((o = !1), e.classList.remove("active"));
    }),
    e.addEventListener("click", function (e) {
      (e.preventDefault(), o ? (t.stop(), (o = !1)) : (t.start(), (o = !0)));
    }),
    e.addEventListener("keydown", (e) => {
      ("Space" !== e.code && "Enter" !== e.code) ||
        (e.preventDefault(), o ? t.stop() : t.start());
    }));
}
function search_drawer_tab() {
  let e = document.querySelectorAll(".predictive-tab-item");
  e &&
    Array.from(e).forEach(function (e) {
      setTimeout(function () {
        e.addEventListener("click", function (t) {
          if ((t.preventDefault(), e.classList.contains("is-selected")))
            return !1;
          let o = e.closest(".shopify-section"),
            r = o.querySelector(".predictive-tab-item.is-selected"),
            i = o.querySelector(".content_active"),
            s = o.querySelector("." + e.dataset.filter);
          s &&
            (r && r.classList.remove("is-selected"),
            i &&
              (i.classList.remove("content_active"),
              (i.style.display = "none")),
            e.classList.add("is-selected"),
            s.classList.add("content_active"),
            (s.style.display = "block"));
        });
      }, 400);
    });
}
function collectionSwatch(e = document) {
  let t = e.querySelectorAll("[data-swatch-colors] .variant-option");
  Array.from(t).forEach(function (e) {
    if (e.dataset.echoSwatchBound) return;
    e.dataset.echoSwatchBound = "true";
    e.addEventListener("change", function (t) {
      t.preventDefault();
      let o = e.closest("[data-swatch-colors]"),
        r = e.closest(".product-card");
      if (o) {
        let t = o.querySelector("li.variant-option.selected");
        (t && t.classList.remove("selected"), e.classList.add("selected"));
        let i = e.querySelector(".hidden");
        if (i && r && r.querySelector(".product-img .media")) {
          r.querySelector(".product-img .media").innerHTML = i.innerHTML;
        }
      }
    });
  });
}
function featuredImage(e, t) {
  if (e.featured_media) {
    let o = e.featured_media.id,
      r = t.querySelector("#productmedia-" + o),
      i = t.querySelector("[data-product-main-media]");
    if (r && i)
      if (i.classList.contains("flickity-enabled")) {
        let e = Array.from(r.parentElement.children).indexOf(r);
        Flickity.data(i).select(e);
      } else {
        let e = i.children.length,
          t = i.firstChild;
        e > 1 && i.insertBefore(r, t);
      }
  }
}
function thumbnailChange(e = document) {
  let t = e.querySelectorAll('a.thumbnail_link[href^="#"]');
  t &&
    t.forEach((e) => {
      e.onclick = function (t) {
        t.preventDefault();
        let o = e.closest("[data-product-media]").querySelector(this.hash),
          r = document.getElementById("showMoreButton");
        o &&
          (o.classList.contains("hidden-media") && r.click(),
          isOnScreen(o) || o.scrollIntoView({ behavior: "smooth" }));
      };
    });
}
function bundleProductInit(e = document) {
  let t = e.querySelector("[data-product-bundle-wrapper]");
  if (t) {
    let e = t.querySelectorAll("[data-product-grid]");
    Array.from(e).forEach(function (e) {
      let o = e.querySelector("[data-bundle-product-options]");
      o &&
        o.addEventListener("change", function () {
          let t = o.options[o.selectedIndex];
          if (t) {
            let o = e.querySelector(".bundle-product-id");
            o && (o.value = t.value);
            let r = e.querySelector(".actual-price");
            r && (r.innerHTML = t.dataset.price);
            let i = e.querySelector(".compare-price");
            i &&
              (t.dataset.comparePrice
                ? ((i.innerHTML = t.dataset.comparePrice),
                  i.classList.remove("hidden"))
                : i.classList.add("hidden"));
          }
        });
      let r = e.querySelector("[data-add-to-bundle]");
      r &&
        r.addEventListener("click", function () {
          let o = e.querySelector(".bundle-product-id");
          (o &&
            (r.classList.contains("active")
              ? (o.setAttribute("disabled", !0),
                r.classList.remove("active"),
                (r.innerText = r.dataset.text))
              : (o.removeAttribute("disabled"),
                (r.innerText = r.dataset.addedText),
                r.classList.add("active"))),
            setTimeout(() => {
              let e = t.querySelectorAll(".bundle-product-id:not([disabled])"),
                o = t.querySelector("[data-add-to-cart]");
              o &&
                (e.length > 1
                  ? o.removeAttribute("disabled")
                  : o.setAttribute("disabled", !0));
            }, 500));
        });
    });
  }
}
function SidedrawerEventInit(e = document) {
  let t = e.querySelectorAll("[data-side-drawer-open]");
  Array.from(t).forEach(function (t) {
    t.addEventListener("click", (o) => {
      (o.preventDefault(),
        e.classList &&
          e.classList.contains("product__wrapper") &&
          (e = e.closest(".shopify-section")));
      let r = t.getAttribute("href"),
        i = r ? document.querySelector(r) : null;
      if (!i && e && e.querySelector) i = e.querySelector(r);
      if (i) {
        let e = i.querySelector("[data-recommendation-popup]");
        if (i.classList.contains("popup")) {
          if (
            ((i.style.display = "flex"),
            setTimeout(() => {
              i.classList.add("popup-visible");
            }, 300),
            "product-fetured-media-popup" == i.getAttribute("id"))
          ) {
            let e = t.getAttribute("data-index"),
              o = i.querySelector("[data-slideshow]");
            if (o) {
              o.classList.contains("flickity-enabled") || slideshowInit(o);
              let r = typeof Flickity !== "undefined" ? Flickity.data(o) : null;
              r &&
                (r.selectedElements.length >= r.cells.length
                  ? (o.classList.add("disable-arrows"),
                    (r.options.draggable = !1),
                    r.updateDraggable())
                  : ((r.options.draggable = !0),
                    r.updateDraggable(),
                    o.classList.remove("disable-arrows")),
                r.resize(),
                null != e && r.select(e),
                setTimeout(function () {
                  r.resize();
                }, 50));
              let s = i.querySelector("media-lightbox-viewer");
              s && "function" == typeof s.swiperSlide && s.swiperSlide();
            }
          }
        } else {
          if (((i.style.display = "flex"), t.classList.contains("search"))) {
            const e = i.querySelector("[data-search-drawer]");
            e && e.classList.remove("hidden");
          }
          (setTimeout(() => {
            i.classList.add("sidebar-visible");
          }, 300),
            e &&
              !e.classList.contains("active") &&
              (setTimeout(() => {
                e.classList.add("active");
              }, 1e3),
              slideshowElements()));
        }
        if (
          (setTimeout(() => {
            focusElementsRotation(i);
          }, 1e3),
          t.classList.contains("search"))
        ) {
          document.querySelector("body").classList.add("search-drawer-open");
          let e = i.querySelector("[data-search-drawer]");
          e && e.classList.remove("hidden");
          let t = e && e.querySelector("input[data-search-input]");
          t &&
            setTimeout(() => {
              t.focus();
            }, 1e3);
        }
        (document.querySelector("body").classList.add("no-scroll"),
          document.querySelector("body").classList.add("popup-open"));
      }
    });
  });
  let o = e.querySelectorAll("[data-side-drawer-close]");
  Array.from(o).forEach(function (e) {
    e.addEventListener("click", (t) => {
      t.preventDefault();
      let o,
        r = e.closest("[data-side-drawer]");
      if (
        (e.closest("[data-side-drawer]") &&
          (o = e
            .closest("[data-side-drawer]")
            .querySelector("[data-recommendation-popup]")),
        o &&
          e.closest(".side-drawer ").classList.contains("side-search-drawer") &&
          document.querySelector("body").classList.remove("search-drawer-open"),
        r &&
          (o &&
          o.querySelector(".cart-recommandation-popup-inner") &&
          o.classList.contains("active")
            ? (setTimeout(function () {
                o.classList.remove("active");
              }, 200),
              setTimeout(function () {
                (r.classList.remove("sidebar-visible", "popup-visible"),
                  document.querySelector("body").classList.remove("no-scroll"),
                  document
                    .querySelector("body")
                    .classList.remove("popup-open"));
              }, 1e3),
              setTimeout(function () {
                r.style.display = "flex";
              }, 500),
              setTimeout(function () {
                r.style.display = "none";
              }, 1500))
            : (setTimeout(function () {
                r.style.display = "none";
              }, 500),
              r.classList.remove("sidebar-visible", "popup-visible"),
              document.querySelector("body").classList.remove("no-scroll"),
              document.querySelector("body").classList.remove("popup-open")),
          r.querySelectorAll("video").forEach((e) => {
            e.muted = !0;
          }),
          r.querySelectorAll("[data-video-audio]").forEach((e) => {
            e.classList.remove("active");
          }),
          stopFocusRotation(),
          previousFocusElement && previousFocusElement.focus(),
          (previousFocusElement = ""),
          r.classList.contains("address-sidebar")))
      ) {
        let e = r.querySelector("form");
        e && e.reset();
      }
    });
  });
}
function get_header_height() {
  let e = document.querySelector("[data-header-section]");
  if (
    (document
      .querySelector("body")
      .style.setProperty("--dynamicheaderHeight", "0px"),
    e)
  ) {
    let t = e.closest(".main-header");
    if (!t) return;
    if (t.classList.contains("sticky-header")) {
      document
        .querySelector("body")
        .style.setProperty("--headerHeight", `${t.offsetHeight}px`);
      let e = t.getBoundingClientRect().height.toFixed(2);
      document
        .querySelector("body")
        .style.setProperty("--dynamicheaderHeight", `${e}px`);
    } else
      document
        .querySelector("body")
        .style.setProperty("--headerHeight", `${t.offsetHeight}px`);
    window.addEventListener("resize", function () {
      setTimeout(function () {
        let t = e.closest(".main-header"),
          o = t.getBoundingClientRect().height;
        (t.classList.contains("sticky-header"),
          document
            .querySelector("body")
            .style.setProperty("--headerHeight", `${o}px`));
      }, 500);
    });
  }
}
function quickviewElements(e = document) {
  let t = e.querySelectorAll("[data-quick-view]");
  Array.from(t).forEach(function (e) {
    initQuickviewAction(e);
  });
}
function initQuickviewAction(e) {
  e.addEventListener("click", (t) => {
    t.preventDefault();
    var o = e.getAttribute("href");
    o.indexOf("?") > -1 && (o = (o = o.split("?"))[0]);
    var r = o + "?section_id=product-quick-view";
    let i = document.querySelector(".quickview-drawer");
    ((i.querySelector(".quickview-drawer-content").innerHTML = preLoadLoadGif),
      e.classList.add("disabled"),
      setTimeout(function () {
        document
          .querySelector(".quickview-drawer")
          .classList.add("sidebar-visible");
      }, 300),
      (document.querySelector(".quickview-drawer").style.display = "flex"),
      document.querySelector("body").classList.add("no-scroll"),
      fetch(r)
        .then((e) => e.text())
        .then((t) => {
          var o = new DOMParser()
            .parseFromString(t, "text/html")
            .querySelector(".shopify-section")
            .querySelector(".quickview-drawer-content");
          i &&
            ((i.querySelector(".quickview-drawer-content").innerHTML =
              o.innerHTML),
            setTimeout(function () {
              (document.querySelector("body").classList.add("no-scroll"),
                getATCelement(),
                Shopify.PaymentButton && Shopify.PaymentButton.init(),
                slideshowElements(i),
                getQuantityElement(i),
                focusElementsRotation(i),
                e.classList.remove("disabled"),
                SidedrawerEventInit(),
                customSliderArrowsEvents(i),
                addMultiplier(),
                outSideClickTrigger(i));
            }, 500));
        })
        .catch((e) => {}));
  });
}
function accordion() {
  var e,
    t = document.querySelectorAll("[data-collapsible-content]");
  for (e = 0; e < t.length; e++)
    t[e].addEventListener("click", function () {
      this.classList.toggle("active");
      var e = this.nextElementSibling;
      e.style.maxHeight
        ? (e.style.maxHeight = null)
        : (e.style.maxHeight = e.scrollHeight + "px");
    });
  let o = document.querySelector(".modal__close-button");
  o &&
    o.addEventListener("click", function () {
      (this.closest(".announcement-bar--content")
        .querySelector(".active")
        .classList.remove("active"),
        (this.closest(".announcement-collapsible-content").style.maxHeight =
          null));
    });
}
function lookbook(e = document) {
  let t = e.querySelectorAll(".hotspot-dot");
  Array.from(t).forEach(function (t) {
    t.addEventListener("click", function (o) {
      o.preventDefault();
      let r = e.querySelectorAll(".product-hotspot.active");
      (t.parentElement.classList.add("active"),
        Array.from(r).forEach(function (e) {
          e.classList.contains("active") && e.classList.remove("active");
        }));
    });
  });
}
function marqueeTextAutoplay(e = document) {
  let t = e.querySelectorAll("[data-marquee]");
  Array.from(t).forEach((e) => {
    if (!e.querySelector("[data-marque-node]")) return !1;
    let t = !1,
      o = !1;
    (marqueeTextAutoplayInit(e),
      window.addEventListener("resize", function () {
        window.innerWidth > 767 && 0 == o
          ? (marqueeTextAutoplayInit(e), (o = !0), (t = !1))
          : window.innerWidth < 768 &&
            0 == t &&
            (marqueeTextAutoplayInit(e), (t = !0), (o = !0));
      }));
  });
}
function marqueeTextAutoplayInit(e) {
  let t = parseInt(e.getAttribute("data-marquee-speed") || 15);
  window.innerWidth < 768 &&
    e.hasAttribute("data-marquee-speed-mobile") &&
    (t = parseInt(e.getAttribute("data-marquee-speed-mobile")));
  const node = e.querySelector("[data-marque-node]");
  if (!node || !e.parentElement) return;
  const o = e.clientWidth,
    r = node.clientWidth;
  let i = 1 + (Math.max(1600, o) - 375) / 1225;
  e.parentElement.style.setProperty(
    "--marqueeSpeed",
    `${((t * i * r) / o).toFixed(3)}s`,
  );
}
function count_number(e) {
  return (e < 10 ? "0" : "") + e;
}
function countDownInit(e) {
  const t = 6e4,
    o = 36e5,
    r = 24 * o;
  var i;
  i = setInterval(function () {
    let s = e.querySelector(".days"),
      n = e.closest(".lowest-price-offer"),
      a = e.closest("[data-counter-sale]"),
      c = e.querySelector(".hours"),
      l = e.querySelector(".minutes"),
      d = e.querySelector(".seconds"),
      u = e.getAttribute("data-launch-date");
    if (null == u || "" == u) return !1;
    let m = new Date(u).getTime() - new Date().getTime(),
      h = count_number(Math.floor(m / r));
    s.innerText = h;
    let p = count_number(Math.floor((m % r) / o));
    c.innerText = p;
    let y = count_number(Math.floor((m % o) / t));
    l.innerText = y;
    let f = count_number(Math.floor((m % t) / 1e3));
    d.innerText = f;
    let v = e.closest(".product-card");
    (v && (v.querySelector("[data-countdown-timer]").style.display = "block"),
      m < 0
        ? (clearInterval(i),
          (e.style.display = "none"),
          n && (n.style.display = "none"),
          a && (a.style.display = "none"))
        : a && (a.style.display = "block"));
  }, 1e3);
}
function getCountDownElments(e = document) {
  let t = e.querySelectorAll("[data-countdown-timer]");
  Array.from(t).forEach(function (e) {
    countDownInit(e);
  });
}
function vertical_scroll(e = document) {
  let t = e.querySelectorAll("[data-carousal-container]");
  Array.from(t).forEach(function (e) {
    let t = e.querySelectorAll(".button_selector"),
      o = e.querySelector("[data-carousal]"),
      r = o.getAttribute("data-speed");
    (Array.from(t).forEach(function (t) {
      t.addEventListener("click", function (r) {
        r.preventDefault();
        let i = e.querySelector(".button_selector.selected"),
          s = t.getAttribute("data-index"),
          n = -e.offsetHeight * s;
        (i && i.classList.remove("selected"),
          t.classList.add("selected"),
          (o.style.top = n + "px"));
      });
    }),
      r && autoplay_slides(e));
  });
}
function autoplay_slides(e) {
  let t = 0;
  !(function o() {
    let r,
      i = e.getElementsByClassName("image-with-text-content"),
      s = e.getElementsByClassName("dot"),
      n = e.querySelector("[data-carousal]").getAttribute("data-speed");
    if (n) {
      for (r = 0; r < i.length; r++) i[r].style.display = "none";
      for (t++, t > i.length && (t = 1), r = 0; r < s.length; r++)
        s[r].className = s[r].className.replace("selected", "");
      ((i[t - 1].style.display = "block"),
        (s[t - 1].className += "selected"),
        setTimeout(o, n));
    }
  })();
}
function getcollageElments(e = document) {
  let t = e.querySelectorAll("[data-testimonial-collage]");
  Array.from(t).forEach(function (e) {
    testimonial_collage(e);
  });
}
function testimonial_collage(e) {
  let t = e.querySelectorAll(".testimonial-item"),
    o = e.querySelectorAll(".testimonial-logo-wrapper");
  Array.from(t).forEach(function (t) {
    let r = t.getAttribute("data-index");
    Array.from(o).forEach(function (o) {
      let i = o.querySelectorAll(".testimonial-logo-holder");
      Array.from(i).forEach(function (o) {
        o.addEventListener("mouseover", function () {
          let i = o.getAttribute("data-index");
          if (o.classList.contains("active")) return !1;
          (active_collage_image(e),
            r == i && (o.classList.add("active"), t.classList.add("active")));
        });
      });
    });
  });
}
function active_collage_image(e) {
  let t = e.querySelector(".testimonial-logo-holder.active"),
    o = e.querySelector(".testimonial-item.active");
  t && o && (t.classList.remove("active"), o.classList.remove("active"));
}
function tab_media_item() {
  let e = document.querySelectorAll("[data-tab-media]"),
    t = "";
  e &&
    Array.from(e).forEach(function (o) {
      o.addEventListener("click", function (r) {
        if (o.classList.contains("active")) return !1;
        let i = o.closest(".shopify-section");
        ((t = o.getAttribute("data-index")), closeVideoMedia(i, !1));
        let s = i.querySelector("[data-tab-media].active");
        (s && s.classList.remove("active", "left", "right"),
          e.forEach(function (e, o) {
            (e.classList.remove("left", "right"),
              t > o ? e.classList.add("left") : e.classList.add("right"));
          }),
          o.classList.add("active"));
      });
    });
}
function initStoreLocator(e = document) {
  if ("" != googleMapApiKey && "" != googleMapId) {
    const e = document.createElement("script");
    ((e.src =
      "https://maps.googleapis.com/maps/api/js?key=" +
      googleMapApiKey +
      "&loading=async&callback=initStoreMap&v=weekly&libraries=marker"),
      (e.async = !0),
      (e.defer = !0),
      document.body.appendChild(e));
  }
}
async function getGeoDetails(e, t) {
  let o = new Promise(function (o, r) {
    e.geocode({ address: t }, function (e, i) {
      "OK" === i
        ? o([e[0].geometry.location.lat(), e[0].geometry.location.lng()])
        : r(new Error("Couldnt't find the location " + t));
    });
  });
  return await o;
}
async function initStoreMap(e = document) {
  let t = e.querySelectorAll("[data-store-locator-map]");
  const { Map: o } = await google.maps.importLibrary("maps"),
    { AdvancedMarkerElement: r } = await google.maps.importLibrary("marker");
  Array.from(t).forEach(function (e) {
    let t = new google.maps.Geocoder();
    const i = e
      .closest(".shopify-section")
      .querySelectorAll("[data-store-locator]");
    if (0 == i.length) return !1;
    const s = new o(e, {
        center: { lat: 0, lng: 0 },
        zoom: 8,
        mapId: googleMapId,
      }),
      n = [];
    function a(e, t) {
      (s.setCenter({ lat: e, lng: t }), s.setZoom(15));
      const o = new r({ position: { lat: e, lng: t }, map: s });
      n.push(o);
    }
    let c = e
      .closest(".shopify-section")
      .querySelector("[data-store-locator].active");
    c ||
      (c = e.closest(".shopify-section").querySelector("[data-store-locator]"));
    let l = c.getAttribute("data-address"),
      d = getGeoDetails(t, l);
    (d.then(function (e) {
      null != d && a(e[0], e[1]);
    }),
      i.forEach((e) => {
        e.addEventListener("click", () => {
          e.getAttribute("data-label");
          let o = e.getAttribute("data-address");
          (i.forEach((t) => {
            t !== e && t.classList.remove("active");
          }),
            e.classList.add("active"));
          let r = getGeoDetails(t, o);
          r.then(function (e) {
            null != r && a(e[0], e[1]);
          });
        });
      }));
  });
}
function getAllDetails(e = document) {
  var t = e.querySelectorAll("details");
  Array.from(t).forEach(function (e) {
    detailsInit(e);
  });
}
function detailsInit(e) {
  let t = e.closest("[data-accordion-details]");
  if (!t) return !1;
  let o = t.closest(".collapsible-content-section"),
    r = "";
  if (o) {
    r = o.querySelector("[data-open-style]").getAttribute("data-open");
  }
  let i = t.querySelectorAll("details");
  e.addEventListener("click", (t) => {
    e.open &&
      i.forEach((t) => {
        t !== e && t.removeAttribute("open");
      });
  });
}
class Accordion {
  constructor(e) {
    ((this.el = e),
      (this.summary = e.querySelector("summary")),
      (this.content = e.querySelector(".detail-expand")),
      (this.animation = null),
      (this.isClosing = !1),
      (this.isExpanding = !1),
      this.summary.addEventListener("click", (e) => this.onClick(e)));
  }
  onClick(e) {
    e.preventDefault();
    const t = this.el.getAttribute("data-accordion-group");
    if (t && (!this.el.open || this.isClosing)) {
      document
        .querySelectorAll(`[data-accordion-group="${t}"]`)
        .forEach((e) => {
          if (e !== this.el && e.open) {
            const t = accordionInstances.get(e);
            t && !t.isClosing && t.shrink();
          }
        });
    }
    ((this.el.style.overflow = "hidden"),
      this.isClosing || !this.el.open
        ? this.open()
        : (this.isExpanding || this.el.open) && this.shrink());
  }
  shrink() {
    this.isClosing = !0;
    const e = `${this.el.offsetHeight}px`,
      t = `${this.summary.offsetHeight}px`;
    (this.animation && this.animation.cancel(),
      (this.el.style.overflow = "hidden"),
      (this.animation = this.el.animate(
        { height: [e, t] },
        { duration: 400, easing: "ease-out" },
      )),
      (this.animation.onfinish = () => this.onAnimationFinish(!1)),
      (this.animation.oncancel = () => (this.isClosing = !1)));
  }
  open() {
    ((this.el.style.height = `${this.el.offsetHeight}px`),
      (this.el.open = !0),
      window.requestAnimationFrame(() => this.expand()));
  }
  expand() {
    this.isExpanding = !0;
    const e = `${this.el.offsetHeight}px`,
      t = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    (this.animation && this.animation.cancel(),
      (this.el.style.overflow = "hidden"),
      (this.animation = this.el.animate(
        { height: [e, t] },
        { duration: 400, easing: "ease-out" },
      )),
      (this.animation.onfinish = () => this.onAnimationFinish(!0)),
      (this.animation.oncancel = () => (this.isExpanding = !1)));
  }
  onAnimationFinish(e) {
    ((this.el.open = e),
      (this.animation = null),
      (this.isClosing = !1),
      (this.isExpanding = !1),
      (this.el.style.height = this.el.style.overflow = ""));
  }
}
const accordionInstances = new WeakMap();
function detailDisclouserInit(e = document) {
  let t = e.querySelectorAll("[data-accordion-open]");
  t &&
    Array.from(t).forEach((e) => {
      const t = new Accordion(e);
      accordionInstances.set(e, t);
    });
}
function videoBanner() {
  document.documentElement.scrollTop;
  var e = document.querySelector("[data-video-banner]");
  let t = 0,
    o = 0;
  if (!e) return !1;
  window.addEventListener("scroll", function () {
    (isOnScreen(e)
      ? ((t += 0.1), (o += 1), document.documentElement.scrollTop)
      : document.documentElement.scrollTop,
      document.documentElement.scrollTop);
  });
}
function initHotspot(e = document) {
  console.log("function call");
  let t = e.querySelectorAll("[data-hotspot-dot]"),
    o = e.querySelectorAll(".product-cross-icon");
  (o &&
    Array.from(o).forEach((e) => {
      e.addEventListener("click", function (t) {
        (t.preventDefault(),
          e
            .closest(".hotspot-product-main-inner.active")
            .classList.remove("active"),
          e
            .closest(".hotspot-item")
            .querySelector("[data-hotspot-dot].active")
            .classList.remove("active"));
      });
    }),
    t &&
      Array.from(t).forEach((e) => {
        e.addEventListener("click", function (t) {
          if ((t.preventDefault(), this.classList.contains("active")))
            return (
              this.classList.remove("active"),
              this.closest(".hotspot-item")
                .querySelector(".hotspot-product-main-inner.active")
                .classList.remove("active"),
              !1
            );
          let o = this.getAttribute("data-product"),
            r = this.closest(".hotspot-item").querySelector(
              '.hotspot-product-main-inner[data-id="' + o + '"]',
            );
          if (
            (this.closest("[data-hotspot-buttons]").querySelector(
              "[data-hotspot-dot].active",
            ) &&
              this.closest(".hotspot-item").querySelector(
                ".hotspot-product-main-inner.active",
              ) &&
              (e
                .closest("[data-hotspot-buttons]")
                .querySelector("[data-hotspot-dot].active")
                .classList.remove("active"),
              this.closest(".hotspot-item")
                .querySelector(".hotspot-product-main-inner.active")
                .classList.remove("active")),
            r)
          ) {
            r
              .closest(".hotspot-product-main")
              .querySelector(".hotspot-product-main-inner") &&
              r.classList.add("active");
          }
          this.closest(".hotspot-item").querySelector("[data-hotspot-dot]") &&
            this.classList.add("active");
        });
      }));
}
function detect_active_testimonial() {
  var e = $("#testimonial-cards .testimonial-item:first-child").data("class");
  ($("#testimonial-dots li").removeClass("active"),
    $("#testimonial-dots li[data-class=" + e + "]").addClass("active"));
}
function testimonialInit() {
  if (typeof $ === "undefined") return;
  $("#testimonial-dots li").click(function () {
    ($("#testimonial-dots li").removeClass("active"),
      $(this).addClass("active"));
    var e = $(this).attr("data-class");
    ($("#testimonial-cards .testimonial-item[data-class=" + e + "]")
      .hide()
      .prependTo("#testimonial-cards")
      .fadeIn(),
      $.each($(".testimonial-item"), function (e, t) {
        $(t).attr("data-position", e + 1);
      }),
      detect_active_testimonial());
  });
  let e = document.querySelector(".testimonial-slides");
  if (e && e.children[0] && e.children[0].children[1]) {
    let t = e.children[0].children[1].clientHeight;
    e.style.height = t + "px";
  }
}
function collectionCarousal() {
  if (typeof $ === "undefined") return;
  $(".collection-carousel-item.hover-effect").hover(
    function () {
      ($(this)
        .closest(".collection-carousel-wrapper")
        .find(".collection-carousel-item")
        .addClass("sibling"),
        $(this).removeClass("sibling"));
    },
    function () {
      $(".collection-carousel-item").removeClass("sibling");
    },
  );
}
function productRecommendations() {
  const e = document.querySelectorAll("[product-recommendations]");
  Array.from(e).forEach(function (e) {
    productRecommendationsInit(e);
  });
}
function productRecommendationsInit(e) {
  const t = e.dataset.url;
  fetch(t)
    .then((e) => e.text())
    .then((t) => {
      const o = document.createElement("div");
      o.innerHTML = t;
      const r = o.querySelector("[product-recommendations]");
      if (r && r.innerHTML.trim().length) {
        ((e.innerHTML = r.innerHTML),
          (e.closest(".shopify-section").style.display = "block"),
          e.querySelector("[data-slideshow]") && slideshowElements(e),
          quickviewElements(e),
          getCountDownElments(e),
          collectionSwatch(e),
          customSliderArrowsEvents(e),
          productCardHoverInit(e),
          badgesAnimation(e),
          aosAnimation && AOS && AOS.refreshHard());
      }
    })
    .catch((e) => {
      console.error(e);
    });
}
function recentlyViewedProducts() {
  let e = document.querySelectorAll("[data-recent-viewed-products]");
  Array.from(e).forEach(function (e) {
    let t = parseInt(e.dataset.product),
      o = e.closest(".shopify-section"),
      r = "starlite-recently-viewed-products",
      i = JSON.parse(window.localStorage.getItem(r) || "[]");
    isNaN(t) ||
      (i.includes(t) || i.unshift(t),
      window.localStorage.setItem(r, JSON.stringify(i.slice(0, 14))),
      i.includes(parseInt(t)) && i.splice(i.indexOf(parseInt(t)), 1));
    let s = i
      .map((e) => "id:" + e)
      .slice(0, 14)
      .join(" OR ");
    fetch(e.dataset.section + s)
      .then((e) => e.text())
      .then((t) => {
        const r = document.createElement("div");
        r.innerHTML = t;
        const i = r.querySelector("[data-recent-viewed-products]");
        if (i && i.innerHTML.trim().length) {
          ((e.innerHTML = i.innerHTML),
            "" != i.innerHTML &&
              e.closest(".shopify-section").classList.remove("hidden"),
            o.querySelector("[data-slideshow]") && slideshowElements(o),
            quickviewElements(o),
            getCountDownElments(o),
            collectionSwatch(o),
            productCardHoverInit(o),
            customSliderArrowsEvents(o),
            badgesAnimation(o),
            aosAnimation && AOS && AOS.refreshHard());
        }
      })
      .catch((e) => {
        console.error(e);
      });
  });
}
try {
  if (
    document.querySelector(
      ".youtubeVideo,.sr-youtube-video,deferred-media[data-type='youtube']",
    )
  ) {
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag &&
      firstScriptTag.parentNode &&
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    ytApiLoaded = !0;
  }
} catch (err) {
  console.error(err);
}
function onYouTubeIframeAPIReady() {
  let e = document.querySelectorAll(".youtubeVideo");
  Array.from(e).forEach(function (e) {
    let t = e.getAttribute("id"),
      o = e.getAttribute("data-id");
    new YT.Player(t, {
      videoId: o,
      playerVars: {
        showinfo: 0,
        controls: 0,
        fs: 0,
        rel: 0,
        height: "100%",
        width: "100%",
        iv_load_policy: 3,
        html5: 1,
        loop: 1,
        autoplay: 1,
        playsinline: 1,
        modestbranding: 1,
        disablekb: 1,
        showinfo: 0,
        wmode: "opaque",
      },
      events: {
        onReady: onYouTubePlayerReady,
        onStateChange: onYouTubePlayerStateChange,
      },
    });
  });
}
function onYouTubePlayerReady(e) {
  (e.target.mute(), e.target.playVideo());
}
function onYouTubePlayerStateChange(e) {
  if (1 == e.data) {
    let t = e.target.g.closest("deferred-media");
    if (t) {
      let e = t.querySelector(".deferred-media-placeholder");
      e && (e.style.display = "none");
    }
  }
  0 == e.data ? e.target.playVideo() : closeVideoMedia();
}
function mp4VideoReady() {
  document.querySelectorAll("video").forEach(function (e) {
    e.onplay = function () {
      closeVideoMedia();
    };
  });
}
function vimeoVideoReady(e = document) {
  e.querySelectorAll(".sr-vimeo-video").forEach(function (e) {
    let t = e.getAttribute("id");
    new Vimeo.Player(t).on("play", function () {
      closeVideoMedia();
    });
  });
}
function customDropdownElements(e = document) {
  let t = e.querySelectorAll(".detail-box");
  Array.from(t).forEach(function (e) {
    let t = e.querySelector(".detail-summary");
    t &&
      (t.addEventListener("click", (o) => {
        o.preventDefault();
        let r = t.nextElementSibling,
          i = r ? r.querySelector(".custom-select-list") : null;
        (i &&
          0 === i.children.length &&
          fetch(window.Shopify.routes.root + "?section_id=country-list")
            .then((e) => e.text())
            .then((e) => {
              let t = new DOMParser().parseFromString(e, "text/html");
              i.innerHTML = t.querySelector(
                "#shopify-section-country-list",
              ).innerHTML;
            }),
          e.classList.toggle("active"),
          DOMAnimations.slideToggle(e.querySelector(".detail-expand"), 300));
      }),
      (e.onkeydown = function (e) {
        "BUTTON" !== t.tagName &&
          ((13 !== e.keyCode && 32 !== e.keyCode) || t.click());
      }));
    let o = e.querySelector(".detail-expand");
    (o &&
      o.addEventListener("click", (t) => {
        (e.classList.remove("active"),
          DOMAnimations.slideUp(e.querySelector(".detail-expand"), 300));
      }),
      document.addEventListener("click", function (t) {
        let o = t.target;
        if (e.contains(o) || o === e) return !1;
        e.classList.contains("active") &&
          (e.classList.remove("active"),
          DOMAnimations.slideUp(e.querySelector(".detail-expand"), 300));
      }));
  });
}
function onHoverMenuElements(e = document) {
  const t = (t = e) => {
    const o = t.querySelectorAll(".header-categories-wrapper.style_2");
    Array.from(o).forEach((e) => {
      const t =
        e.querySelector(".categories-inner--submenu:not(.hidden)") ||
        e.querySelector(".categories-inner--submenu");
      if (!t) return;
      const o = Math.ceil(t.getBoundingClientRect().height);
      o > 0 && e.style.setProperty("--category-height", `${o}px`);
    });
  };
  let o = e.querySelectorAll(".categories-submenu-item");
  Array.from(o).forEach(function (e) {
    e.addEventListener("mouseover", () => {
      const t = e.closest(".header-categories-wrapper");
      if (
        t &&
        (Array.from(t.querySelectorAll(".categories-inner--submenu")).forEach(
          function (t) {
            if (e.classList.contains("sub-category-menu")) {
              const o = e.dataset.index;
              t.dataset.index === o
                ? t.classList.remove("hidden")
                : t.classList.add("hidden");
            }
          },
        ),
        !e.classList.contains("active") &&
          (Array.from(
            e.closest("ul").querySelectorAll(".categories-submenu-item"),
          ).map((e) => {
            e.classList.remove("active");
          }),
          e.classList.add("active"),
          e.querySelector(".categories-inner--submenu")))
      ) {
        const t = e
          .querySelector(".categories-inner--submenu")
          .getBoundingClientRect().height;
        e.closest(".header-categories-wrapper").style.setProperty(
          "--category-height",
          `${t}px`,
        );
      }
    });
  });
  let r = e.querySelectorAll(".custom-details-disclosure");
  Array.from(r).forEach(function (t) {
    (t.addEventListener("mouseover", () => {
      if (t.classList.contains("open")) return !1;
      (t.parentElement.classList.contains("has-children") &&
        document.querySelector("body").classList.add("megamenu-open"),
        Array.from(
          document.querySelectorAll("[data-result-container]"),
        ).forEach(function (e) {
          e.classList.add("hidden");
        }),
        Array.from(document.querySelectorAll("[data-search-drawer]")).forEach(
          function (e) {
            (e.classList.add("hidden"), e.classList.remove("active"));
          },
        ),
        document
          .querySelector("body")
          .classList.remove("search-drawer-open", "no-scroll"),
        Array.from(
          e.querySelectorAll(".category-custom-details-disclosure"),
        ).forEach(function (e) {
          e.hasAttribute("open") &&
            (e.classList.remove("open"),
            e.removeAttribute("open"),
            document.querySelector("body").classList.remove("megamenu-open"));
        }),
        Array.from(e.querySelectorAll(".custom-details-disclosure")).forEach(
          function (e) {
            t == e
              ? (t.setAttribute("open", ""),
                t.classList.add("open"),
                t.closest(".header-nav-blocks").classList.add("megamenu-block"))
              : (e.removeAttribute("open"),
                e.classList.remove("open"),
                Array.from(
                  e.querySelectorAll(".sub-menu-custom-details-disclosure"),
                ).forEach(function (e) {
                  e.removeAttribute("open");
                }));
          },
        ));
    }),
      t.addEventListener("mouseleave", () => {
        (t.classList.remove("open"),
          t.removeAttribute("open"),
          document.querySelector("body").classList.remove("megamenu-open"));
      }));
  });
  let i = e.querySelectorAll(".sub-menu-custom-details-disclosure");
  Array.from(i).forEach(function (e) {
    e.addEventListener("mouseover", () => {
      Array.from(
        document.querySelectorAll(".sub-menu-custom-details-disclosure"),
      ).forEach(function (t) {
        e == t ? t.setAttribute("open", "") : t.removeAttribute("open");
      });
    });
  });
  let s = e.querySelectorAll(".category-custom-details-disclosure");
  (Array.from(s).forEach(function (o) {
    o.addEventListener("click", () => {
      const r = o.closest(".header-categories-wrapper");
      r &&
        (Array.from(r.querySelectorAll(".categories-inner--submenu")).forEach(
          function (e) {
            1 == e.dataset.index
              ? e.classList.remove("hidden")
              : e.classList.add("hidden");
          },
        ),
        setTimeout(function () {
          o.hasAttribute("open")
            ? (t(e),
              Array.from(
                document.querySelectorAll("[data-search-input]"),
              ).forEach(function (e) {
                e.value = "";
              }),
              Array.from(
                document.querySelectorAll("[data-result-container]"),
              ).forEach(function (e) {
                e.classList.add("hidden");
              }),
              Array.from(
                document.querySelectorAll("[data-search-drawer]"),
              ).forEach(function (e) {
                (e.classList.add("hidden"), e.classList.remove("active"));
              }),
              document
                .querySelector("body")
                .classList.remove("search-drawer-open", "no-scroll"),
              document.querySelector("body").classList.add("megamenu-open"))
            : document.querySelector("body").classList.remove("megamenu-open");
        }, 100));
    });
  }),
    Array.from(e.querySelectorAll("[data-child-index]")).forEach(function (e) {
      e.addEventListener("mouseover", () => {
        if (e.classList.contains("active")) return;
        (e
          .closest("[data-second-level]")
          .querySelectorAll("[data-child]")
          .forEach(function (e) {
            e.classList.remove("active");
          }),
          e
            .closest("[data-second-level]")
            .querySelectorAll("[data-grandchild]")
            .forEach(function (e) {
              e.classList.remove("active");
            }));
        const t = e.getAttribute("data-child-index");
        (e.classList.add("active"),
          e
            .closest("li")
            .querySelector(`[data-grandchild-index="third-level-menu-${t}"]`)
            .classList.add("active"));
      });
    }),
    requestAnimationFrame(() => {
      t(e);
    }));
}
function collectionTabs(e = document) {
  let t = e.querySelectorAll(".product-tab-item");
  (setTimeout(() => {
    Array.from(e.querySelectorAll(".tab-contents-item.hidden")).forEach(
      function (e) {
        Array.from(e.querySelectorAll("[data-product-grid]")).forEach(
          function (e) {
            e.classList.remove("aos-animate");
          },
        );
      },
    );
  }, 1e3),
    Array.from(t).forEach(function (e) {
      e.addEventListener("click", () => {
        let t = e.closest(".shopify-section"),
          o = t.querySelector(".product-tab-item.active");
        (o && o.classList.remove("active"), e.classList.add("active"));
        let r = e.getAttribute("data-tab"),
          i = t.querySelector("#" + r),
          s = t.querySelectorAll(".tab-contents-item");
        if (
          (Array.from(s).forEach(function (e) {
            e.id === r
              ? (e.classList.remove("hidden"),
                setTimeout(() => {
                  Array.from(e.querySelectorAll("[data-product-grid]")).forEach(
                    function (e) {
                      e.classList.add("aos-animate");
                    },
                  );
                }, 100))
              : (e.classList.add("hidden"),
                Array.from(e.querySelectorAll("[data-product-grid]")).forEach(
                  function (e) {
                    e.classList.remove("aos-animate");
                  },
                ));
          }),
          i)
        ) {
          let e = i.querySelector("[data-slideshow]");
          e.classList.contains("flickity-enabled") && slideshowInit(e);
          let t = Flickity.data(e);
          t &&
            (t.selectedElements.length >= t.cells.length
              ? (e.classList.add("disable-arrows"),
                (t.options.draggable = !1),
                t.updateDraggable())
              : ((t.options.draggable = !0),
                t.updateDraggable(),
                e.classList.remove("disable-arrows")),
            t.resize());
        }
      });
    }));
}
function collectionCardImageCarousel(e = document) {
  e.querySelectorAll(
    "[data-collection-card-carousel]:not([data-carousel-initialized])",
  ).forEach(function (e) {
    const t = e.querySelectorAll(".collection-card-carousel__slide");
    if (t.length <= 1) return;
    e.setAttribute("data-carousel-initialized", "true");
    let o = 0;
    const r = parseInt(e.dataset.interval, 10) || 4e3;
    setInterval(function () {
      (t[o].classList.remove("is-active"),
        (o = (o + 1) % t.length),
        t[o].classList.add("is-active"));
    }, r);
  });
}
function featuredImages(e = document) {
  let t = e.querySelectorAll("[data-featured-image-wrapper]");
  Array.from(t).forEach(function (e) {
    let t = window.pageYOffset,
      o = e.offsetTop + e.offsetHeight;
    (t + window.innerHeight > o
      ? (e.querySelector(".item-second") &&
          (e.querySelector(".item-second").style.cssText =
            "transform: translate3d(0px, 0vw, 0px"),
        e.querySelector(".item-third") &&
          (e.querySelector(".item-third").style.cssText =
            "transform: translate3d(0px, 0vw, 0px"))
      : (e.querySelector(".item-second") &&
          (e.querySelector(".item-second").style.cssText =
            "transform: translate3d(0px, -10vw, 0px"),
        e.querySelector(".item-third") &&
          (e.querySelector(".item-third").style.cssText =
            "transform: translate3d(0px, -20vw, 0px")),
      window.addEventListener("scroll", function () {
        isOnScreen(e) &&
          Array.from(e.querySelectorAll("[data-featured-image]")).forEach(
            function (t) {
              let o = 0;
              (t.classList.contains("item-second") && (o = -10),
                t.classList.contains("item-third") && (o = -20));
              let r = window.pageYOffset,
                i = e.offsetTop,
                s = Math.min(500, window.innerHeight),
                n = i - r;
              if (n >= 0) {
                let e = ((100 - ((s - n) / s) * 100) / 100) * o,
                  r = Math.max(o, Math.min(e, 0));
                t.style.cssText = `transform: translate3d(0px, ${r}vw, 0px)`;
              }
            },
          );
      }));
  });
}
function announcementCollapsiblecontent(e = document) {
  let t = e.querySelectorAll(".announcement-btn"),
    o = e.querySelectorAll(".announcement-dropdown");
  Array.from(t).forEach(function (t) {
    t.addEventListener("click", () => {
      e.querySelector(".announcement-btn.active");
      (t.classList.toggle("active"),
        document.querySelector("body").classList.contains("announcement-open")
          ? (document
              .querySelector("body")
              .classList.remove("announcement-open"),
            document.querySelector("body").classList.remove("no-scroll"))
          : (document.querySelector("body").classList.add("announcement-open"),
            document.querySelector("body").classList.add("no-scroll")));
      let r = t.getAttribute("data-toggle");
      Array.from(o).forEach(function (e) {
        e.id === r && e.classList.toggle("show");
      });
    });
  });
}
function headerNavigationPosition(e = document) {
  if (window.innerWidth < 992) return !1;
  let t = e.querySelectorAll("[data-navigation-item]");
  Array.from(t).forEach(function (e) {
    e.classList.remove("left-menu");
    let t = window.innerWidth - 200,
      o = e.offsetLeft + e.clientWidth;
    (e.querySelector(".nav-submenu.inner") &&
      (o += e.querySelector(".nav-submenu.inner").clientWidth),
      o >= t && e.classList.add("left-menu"));
  });
}
window.addEventListener("resize", (e) => {
  (setTimeout(function () {
    if (typeof Flickity === "undefined") return;
    let e = document.querySelectorAll("[data-slideshow]");
    Array.from(e).forEach(function (e) {
      if (
        (e.classList.contains("flickity-enabled") || slideshowInit(e),
        e.classList.contains("slideshow-section") && e.dataset.slideshow)
      ) {
        let t;
        try {
          t = JSON.parse(e.dataset.slideshow);
        } catch (err) {
          t = null;
        }
        if (t && !e.classList.contains("flickity-enabled")) {
          slideshowInit(e);
        }
        document.querySelectorAll(".slideshow-thumbnail").forEach(function (e) {
          e.style.transition = "";
        });
      }
      let t = Flickity.data(e);
      t &&
        (t.selectedElements.length >= t.cells.length
          ? (e.classList.add("disable-arrows"),
            (t.options.draggable = !1),
            t.updateDraggable())
          : ((t.options.draggable = !0),
            t.updateDraggable(),
            e.classList.remove("disable-arrows")),
        t.options.autoPlay &&
          "function" == typeof t.playPlayer &&
          t.playPlayer(),
        setTimeout(() => {
          t.resize();
        }, 500));
    });
  }, 500),
    window.innerWidth > 991
      ? document.body.classList.contains("nav-open") &&
        document.body.classList.remove("nav-open")
      : document.querySelector(".category-custom-details-disclosure") &&
        document
          .querySelector(".category-custom-details-disclosure")
          .hasAttribute("open") &&
        (document
          .querySelector(".category-custom-details-disclosure")
          .removeAttribute("open"),
        document.querySelector("body").classList.remove("megamenu-open")),
    headerNavigationPosition());
});
var mouse_is_inside = !1;
function outSideClickTrigger(e = document) {
  let t = e.querySelectorAll(
    "[data-humburger-body],[data-hamburger-menu],.compare-modal-content,[data-button-compare],[data-quick-view],.side-drawer-content,.product-menus-list-item,[data-side-drawer-open],.sr-product-model-item,.header-top-wrap,.header-search,.search-content,[data-search-open],.header-categories-wrapper,.category-custom-details-disclosure,.custom-details-disclosure,.sub-menu-custom-details-disclosure, .announcement-dropdown,.popup-content-inner,[data-cart-drwaer-body]",
  );
  (Array.from(t).forEach(function (e) {
    (e.addEventListener("mouseover", () => {
      mouse_is_inside = !0;
    }),
      e.addEventListener("mouseout", () => {
        mouse_is_inside = !1;
      }));
  }),
    document.addEventListener("click", function () {
      if (!mouse_is_inside) {
        (document.querySelector("body").classList.remove("no-scroll"),
          document.querySelector("body").classList.remove("popup-open"));
        let e = document.querySelector("[data-search-drawer]");
        if (e) {
          let t = e.getAttribute("data-header"),
            o = e.querySelector("[data-result-container]"),
            r = e.querySelector("[data-suggestions-container]");
          (r && r.classList.remove("hidden"),
            e.classList.add("hidden"),
            e.classList.remove("active"),
            document
              .querySelector("body")
              .classList.remove("search-drawer-open"),
            o && o.classList.add("hidden"),
            "logo_with_search_bar" == t &&
              document.querySelector("[data-search-input]") &&
              (document.querySelector("[data-search-input]").value = ""));
        }
        let t = document.querySelector(".announcement-btn.active");
        (t && t.click(),
          Array.from(
            document.querySelectorAll(".categories-inner--submenu"),
          ).forEach(function (e) {
            e.classList.add("hidden");
          }),
          Array.from(
            document.querySelectorAll(".category-custom-details-disclosure"),
          ).forEach(function (e) {
            (e.removeAttribute("open"),
              document.querySelector("body").classList.remove("megamenu-open"));
          }));
      }
    }),
    document.addEventListener("keyup", function (t) {
      if (27 == t.keyCode) {
        let t = document.querySelector("[data-search-drawer]");
        if (t) {
          let e = t.getAttribute("data-header"),
            o = t.querySelector("[data-result-container]"),
            r = t.querySelector("[data-suggestions-container]");
          (r && r.classList.remove("hidden"),
            t.classList.add("hidden"),
            t.classList.remove("active"),
            o && o.classList.add("hidden"),
            "logo_with_search_bar" == e &&
              document.querySelector("[data-search-input]") &&
              (document.querySelector("[data-search-input]").value = ""));
        }
        document.querySelector("body").classList.remove("no-scroll");
        let o = document.querySelector(".announcement-btn.active");
        (o && o.click(),
          Array.from(
            document.querySelectorAll(".categories-inner--submenu"),
          ).forEach(function (e) {
            e.classList.add("hidden");
          }),
          Array.from(
            document.querySelectorAll(".category-custom-details-disclosure"),
          ).forEach(function (e) {
            (e.removeAttribute("open"),
              document.querySelector("body").classList.remove("megamenu-open"));
          }));
        let r = e.querySelectorAll("[data-side-drawer]");
        Array.from(r).forEach(function (e) {
          if (e.classList.contains("collection-filter-sidebar")) return !1;
          if (
            (setTimeout(function () {
              e.style.display = "none";
            }, 300),
            e.classList.remove("sidebar-visible", "popup-visible"),
            document.querySelector("body").classList.remove("no-scroll"),
            stopFocusRotation(),
            previousFocusElement &&
              (previousFocusElement.classList.contains("product-quickview")
                ? previousFocusElement
                    .closest("[data-product-grid]")
                    .querySelector(".product-title") &&
                  (previousFocusElement
                    .closest("[data-product-grid]")
                    .dispatchEvent(new Event("mouseover")),
                  previousFocusElement
                    .closest("[data-product-grid]")
                    .querySelector(".product-title")
                    .focus())
                : previousFocusElement.focus()),
            (previousFocusElement = ""),
            e.classList.contains("address-sidebar"))
          ) {
            let t = e.querySelector("form");
            t && t.reset();
          }
        });
      }
    }),
    document.addEventListener("mouseover", function () {
      mouse_is_inside ||
        (Array.from(
          document.querySelectorAll(".category-custom-details-disclosure"),
        ).forEach(function (e) {
          if (e.hasAttribute("open")) return !1;
          (e.removeAttribute("open"),
            document.querySelector("body").classList.remove("megamenu-open"));
        }),
        Array.from(
          document.querySelectorAll(".custom-details-disclosure"),
        ).forEach(function (e) {
          (e.removeAttribute("open"),
            e.classList.remove("open"),
            e.closest(".header-nav-blocks").classList.remove("megamenu-block"));
        }),
        Array.from(
          document.querySelectorAll(".sub-menu-custom-details-disclosure"),
        ).forEach(function (e) {
          e.removeAttribute("open");
        }));
    }));
}
let lastScrollTop = 0;
function showPosition(e) {
  var t = e.style.position;
  return (
    (e.style.position = "static"),
    (e.style.position = t),
    e.getBoundingClientRect().top
  );
}
function onScrollImageWithText() {
  let e,
    t = 0;
  var o = window.pageYOffset || document.documentElement.scrollTop;
  (o > t ? (e = !1) : o < t && (e = !0), (t = o <= 0 ? 0 : o));
  let r = document.querySelectorAll("[data-image-with-text-grid]");
  r &&
    Array.from(r).forEach(function (t) {
      const o = t.offsetWidth;
      let r = t.getElementsByClassName("image-with-text-content");
      if (r && r.length > 0)
        for (var i = 0; i < r.length; i++) {
          let t = 0;
          if (
            ((t = 0 == i ? 1 : i + 1),
            showPosition(r[i]) > 24 * t && (r[i].style.width = o + "px"),
            showPosition(r[i]) != 24 * t || e)
          ) {
            if (showPosition(r[i]) == 24 * t && e) {
              let e = r[i].offsetWidth;
              r[i].style.width = parseInt(e + 1) + "px";
            }
          } else {
            let e = r[i].offsetWidth;
            r[i].style.width = parseInt(e - 1) + "px";
          }
        }
    });
}
function isScrolledIntoView(e) {
  var t = document.documentElement,
    o =
      (window.pageYOffset || t.scrollTop) -
      (t.clientTop || 0) +
      window.innerHeight;
  return e.offsetTop <= o + 50;
}
function scrollTop() {
  let e = document.querySelector("#back_to_top");
  if (!e) return !1;
  (e.addEventListener("click", function () {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }),
    (window.onscroll = function () {
      document.documentElement.scrollTop > 900
        ? (e.classList.remove("hidden"), e.classList.add("show"))
        : (e.classList.remove("show"), e.classList.add("hidden"));
    }));
}
function productCardHoverInit() {
  productOnHoverQucikviewButton();
}
function productOnHoverQucikviewButton(e = document) {
  let t = document.querySelectorAll(".product-card-item[data-product-hover]");
  Array.from(t).forEach(function (e) {
    e &&
      (e.addEventListener("mouseover", function (o) {
        let r = 0;
        if (
          window.innerWidth > 1024 &&
          e.querySelector(".product-quickview-button")
        ) {
          r =
            e.querySelector(".product-card-img").offsetHeight +
            e.querySelector(".product-card-detail").offsetHeight;
          const o =
            r +
            (e.querySelector(".product-quickview-button").offsetHeight || 0);
          ((e.querySelector(".product-card").style.height = o + "px"),
            (e.style.height = r + "px"),
            e.closest(".flickity-enabled") ||
              (Array.from(t).forEach(function (e) {
                e.querySelector(".product-card").style.zIndex = "1";
              }),
              (e.querySelector(".product-card").style.zIndex = "2")));
        }
      }),
      e.addEventListener("mouseleave", function (o) {
        window.innerWidth > 1024 &&
          e.querySelector(".product-quickview-button") &&
          ((e.querySelector(".product-card").style.height = null),
          (e.style.height = null),
          e.closest(".flickity-enabled") ||
            (Array.from(t).forEach(function (e) {
              e.querySelector(".product-card").style.zIndex = null;
            }),
            (e.querySelector(".product-card").style.zIndex = null)));
      }));
  });
}
function verifyAge(e) {
  e.preventDefault();
  let t = e.target.closest(".age-verification");
  t &&
    (t.classList.remove("active"),
    document.querySelector("body").classList.remove("no-scroll"),
    setCookie("ageVerified", "true", 15));
}
function rejectAgeVerify(e) {
  e.preventDefault();
  let t = e.target,
    o = t.closest(".age-verification-wrapper");
  if (o) {
    let e = o.querySelector(".age-verification-decline");
    e &&
      (t.closest(".age-verification-outer").classList.remove("active"),
      e.classList.add("active"));
  }
}
function backToAgeVerify(e) {
  e.preventDefault();
  let t = e.target,
    o = t.closest(".age-verification-wrapper");
  if (o) {
    let e = o.querySelector(".age-verification-outer");
    e &&
      (t.closest(".age-verification-decline").classList.remove("active"),
      e.classList.add("active"));
  }
}
function compareProducts(e) {
  let t = e.target;
  t.closest(".compare-checkbox").classList.contains("checked_label")
    ? updateCompareProducts(t, "remove")
    : (t.closest("body").querySelector(".compare-basket").classList.add("open"),
      updateCompareProducts(t, "add"));
}
function updateCompareProducts(e, t) {
  let o = "products-compare",
    r = parseInt(e.getAttribute("data-product-id")),
    i = JSON.parse(window.localStorage.getItem(o) || "[]"),
    s = document.querySelectorAll(".js-compare-checkbox");
  if (!isNaN(r)) {
    if ("add" == t)
      (i.includes(r) ||
        (i.push(r),
        Array.from(s).forEach(function (e) {
          let t = parseInt(e.getAttribute("data-product-id"));
          i.includes(t) &&
            i.length < 5 &&
            (e.setAttribute("checked", !0),
            e.closest(".compare-checkbox").classList.add("checked_label"));
        })),
        i.length >= 4
          ? document.querySelector("body").classList.add("no-compare")
          : document.querySelector("body").classList.remove("no-compare"),
        document.querySelector("[data-button-compare]") &&
          (1 == i.length
            ? document
                .querySelector("[data-button-compare]")
                .setAttribute("disabled", !0)
            : document
                .querySelector("[data-button-compare]")
                .removeAttribute("disabled")));
    else {
      if (i.includes(r)) {
        let e = i.indexOf(r);
        e > -1 &&
          (i.splice(e, 1),
          Array.from(s).forEach(function (e) {
            (e.setAttribute("checked", !1),
              e.closest(".compare-checkbox").classList.remove("checked_label"));
            let t = parseInt(e.getAttribute("data-product-id"));
            i.includes(t) &&
              (e.setAttribute("checked", !0),
              e.closest(".compare-checkbox").classList.add("checked_label"));
          }));
      }
      (document.querySelector("body").classList.remove("no-compare"),
        document.querySelector("[data-button-compare]") &&
          (1 == i.length
            ? document
                .querySelector("[data-button-compare]")
                .setAttribute("disabled", !0)
            : document
                .querySelector("[data-button-compare]")
                .removeAttribute("disabled")));
    }
    if (
      (window.localStorage.setItem(o, JSON.stringify(i.slice(0, 4))),
      i.length > 0)
    ) {
      (document.querySelector(".compare-btn-sidebar") &&
        document
          .querySelector(".compare-btn-sidebar")
          .classList.remove("hidden"),
        getCompareGridData(
          i
            .map((e) => "id:" + e)
            .slice(0, 4)
            .join(" OR "),
        ));
    } else
      (document.querySelector(".compare-btn-sidebar") &&
        document.querySelector(".compare-btn-sidebar").classList.add("hidden"),
        document.querySelector("body").querySelector(".compare-basket") &&
          document
            .querySelector("body")
            .querySelector(".compare-basket")
            .classList.remove("open"),
        document
          .querySelector("body")
          .classList.contains("compare-popup-open") &&
          (document
            .querySelector("body")
            .classList.remove("compare-popup-open"),
          document.querySelector("body").classList.remove("no-scroll")),
        document.querySelector("#bucketContainer") &&
          (document.querySelector("#bucketContainer").innerHTML = ""));
  }
}
function compareBarViewToggle(e = document) {
  let t = e.querySelectorAll(".compact-view-button");
  Array.from(t).forEach(function (e) {
    e.addEventListener("click", function (t) {
      e.parentElement.classList.contains("compact-view")
        ? e.parentElement.classList.remove("compact-view")
        : e.parentElement.classList.add("compact-view");
    });
  });
}
function getCompareGridData(e) {
  let t = document.querySelector("[data-compare-product-wrapper]");
  if (t) {
    let o = t.getAttribute("data-section");
    fetch(mainSearchUrl + o + e)
      .then((e) => e.text())
      .then((e) => {
        let t = new DOMParser()
          .parseFromString(e, "text/html")
          .querySelector(".shopify-section");
        document.getElementById("bucketContainer").innerHTML = t.querySelector(
          "[data-compare-items]",
        ).innerHTML;
        let o = document.querySelector("[compare-model-info]");
        (compareButtonContent(),
          (o.innerHTML = t.querySelector(
            "[data-compare-items-info]",
          ).innerHTML),
          getATCelement());
        let r = o
          .querySelector(".compare-modal-results")
          .getAttribute("data-products-count");
        return (
          removeCompareGridData(
            document.querySelectorAll("[data-remove-icon]"),
          ),
          setTimeout(function () {
            0 == r
              ? (o
                  .closest("[data-compare-product-wrapper]")
                  .querySelector(".compare-basket") &&
                  o
                    .closest("[data-compare-product-wrapper]")
                    .querySelector(".compare-basket")
                    .classList.remove("open"),
                o
                  .closest("[data-compare-product-wrapper]")
                  .querySelector(".compare-modal-results") &&
                  (o.querySelector(".compare-modal-results").style.display =
                    "none"),
                o
                  .closest("[data-compare-product-wrapper]")
                  .querySelector(".empty-modal-info") &&
                  (o
                    .querySelector(".compare-modal-results")
                    .querySelector(".empty-modal-info").style.display =
                    "block"),
                o.querySelector("[data-compare-model-close]") &&
                  o.querySelector("[data-compare-model-close]").click())
              : o.closest(".compare-modal-results") &&
                (o
                  .closest(".compare-modal-results")
                  .querySelector(".compare-modal-results") &&
                  (o.querySelector(".compare-modal-results").style.display =
                    "block"),
                o
                  .closest(".compare-modal-results")
                  .querySelector(".empty-modal-info") &&
                  (o
                    .querySelector(".compare-modal-results")
                    .querySelector(".empty-modal-info").style.display =
                    "none"));
          }, 500),
          CloseCompareModel(),
          !1
        );
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
function removeCompareGridData(e) {
  Array.from(e).forEach(function (e) {
    e.addEventListener("click", function (e) {
      e.preventDefault();
      let t = "products-compare",
        o = parseInt(
          this.querySelector(".remove_icon").getAttribute("data-remove"),
        ),
        r = JSON.parse(window.localStorage.getItem(t) || "[]");
      if (r.includes(o)) {
        let e = r.indexOf(o);
        e > -1 && r.splice(e, 1);
      }
      let i = document.querySelectorAll(
        '.js-compare-checkbox[data-product-id="' + o + '"]',
      );
      if (
        (Array.from(i).forEach(function (e) {
          e.closest(".compare-checkbox").classList.contains("checked_label") &&
            e.closest(".compare-checkbox").classList.remove("checked_label");
        }),
        window.localStorage.setItem(t, JSON.stringify(r.slice(0, 4))),
        0 == r.length &&
          (document.querySelector(".compare-btn-sidebar") &&
            document
              .querySelector(".compare-btn-sidebar")
              .classList.add("hidden"),
          document
            .querySelector("body")
            .querySelector(".compare-basket")
            .classList.remove("open"),
          document
            .querySelector("body")
            .classList.contains("compare-popup-open") &&
            (document
              .querySelector("body")
              .classList.remove("compare-popup-open"),
            document.querySelector("body").classList.remove("no-scroll"))),
        r.length >= 0)
      ) {
        getCompareGridData(
          r
            .map((e) => "id:" + e)
            .slice(0, 4)
            .join(" OR "),
        );
      }
      (r.length >= 4
        ? document.querySelector("body").classList.add("no-compare")
        : document.querySelector("body").classList.remove("no-compare"),
        document.querySelector("[data-button-compare]") &&
          (1 == r.length
            ? document
                .querySelector("[data-button-compare]")
                .setAttribute("disabled", !0)
            : document
                .querySelector("[data-button-compare]")
                .removeAttribute("disabled")));
    });
  });
}
function compareButtonContent(e = document) {
  let t = e.querySelector("[data-button-compare]"),
    o = e.querySelector(".compare-modal-content[data-side-drawer]");
  t.addEventListener("click", function () {
    (o &&
      o.classList.contains("popup") &&
      (o.classList.add("popup-visible"),
      (o.style.display = "flex"),
      document.querySelector("body").classList.add("no-scroll")),
      setTimeout(() => {
        focusElementsRotation(o);
      }, 500),
      document.querySelector("body").classList.add("compare-popup-open"));
  });
}
function acceptNewsletterConditions(e) {
  const t = e.target,
    o = t.closest("form").querySelector('button[type="submit"]'),
    r = t.checked;
  (o?.classList.toggle("disabled", !r),
    o.toggleAttribute("disabled", !r),
    o?.toggleAttribute("disabled", !r));
}
function checkedboxCookies() {
  let e = document.querySelectorAll(".js-compare-checkbox"),
    t = JSON.parse(window.localStorage.getItem("products-compare") || "[]"),
    o = t
      .map((e) => "id:" + e)
      .slice(0, 4)
      .join(" OR ");
  (t.length > 0 &&
    (getCompareGridData(o),
    document.querySelector(".compare-btn-sidebar") &&
      document
        .querySelector(".compare-btn-sidebar")
        .classList.remove("hidden")),
    Array.from(e).forEach(function (e) {
      let o = parseInt(e.getAttribute("data-product-id"));
      t.includes(o) &&
        (e.setAttribute("checked", !0),
        e.closest(".compare-checkbox").classList.add("checked_label"));
    }),
    t.length <= 4
      ? document.querySelector("body").classList.add("no-compare")
      : document.querySelector("body").classList.remove("no-compare"),
    document.querySelector("[data-button-compare]") &&
      (1 == t.length
        ? document
            .querySelector("[data-button-compare]")
            .setAttribute("disabled", !0)
        : document
            .querySelector("[data-button-compare]")
            .removeAttribute("disabled")));
}
function CloseCompareModel(e = document) {
  let t = e.querySelectorAll("[data-compare-model-close]");
  Array.from(t).forEach(function (e) {
    e.addEventListener("click", (t) => {
      t.preventDefault();
      let o = e.closest("[data-side-drawer]");
      o &&
        (o.classList.remove("popup-visible"),
        o.classList.contains("popup"),
        document
          .querySelector("body")
          .classList.contains("compare-popup-open") &&
          (document
            .querySelector("body")
            .classList.remove("compare-popup-open"),
          document.querySelector("body").classList.remove("no-scroll")));
    });
  });
  let o = document.querySelector("#closeButton");
  o &&
    o.addEventListener("click", function (e) {
      document.querySelector(".compare-basket").classList.remove("open");
    });
}
function toggleCompareBasket(e) {
  e.preventDefault();
  let t = document.querySelector(".compare-basket");
  t &&
    (t.classList.contains("open")
      ? t.classList.remove("open")
      : t.classList.add("open"));
}
function closeNewsletterOfferPopup(e) {
  e.preventDefault();
  let t = document.querySelector(".newsletter-popup");
  t &&
    (setCookie(
      "newsletterofferPopUpClosed",
      "true",
      newsletterofferPopupExpDays,
    ),
    t.classList.remove("active"),
    document.querySelector("body").classList.remove("no-scroll"));
}
function showMoremedia(e = document) {
  let t = document.getElementById("showMoreButton"),
    o = document.querySelectorAll(".featured_product_image_item");
  return (
    t &&
      t.addEventListener("click", function () {
        let e = "Show More" === t.textContent;
        (o.forEach(function (t, o) {
          o > 3 && t.classList.toggle("hidden-media", !e);
        }),
          (t.textContent = e ? "Show Less" : "Show More"),
          e
            ? setTimeout(function () {
                o[o.length - 1].scrollIntoView();
              }, 100)
            : window.scrollTo({ top: 0, behavior: "smooth" }));
      }),
    !1
  );
}
function announementHeightOnScroll() {
  let e = document.querySelector(".announcement-section");
  if (!e) return !1;
  let t = e.offsetHeight,
    o = window.scrollY;
  if (o > t)
    document
      .querySelector("body")
      .style.setProperty("--announcementHeight", "0px");
  else {
    let e = Math.max(t - o, 0);
    document
      .querySelector("body")
      .style.setProperty("--announcementHeight", `${e}px`);
  }
}
function mobileNavigation(e = document) {
  if (window.echoMobileNavBound) return;
  let t = e.querySelector(".main-header");
  if (t) {
    let e = t.querySelector("[data-mobile-menu]");
    e && (window.echoMobileNavBound = true);
    e &&
      (e.addEventListener("click", function (o) {
        (o.preventDefault(),
          e.classList.contains("active")
            ? (e.classList.remove("active"),
              document.querySelector("body").classList.remove("nav-open"),
              setTimeout(() => {
                Array.from(t.querySelectorAll(".child")).forEach(function (e) {
                  DOMAnimations.slideUp(e);
                });
              }, 200))
            : (e.classList.add("active"),
              document.querySelector("body").classList.add("nav-open")));
      }),
      document.addEventListener("click", function (o) {
        let r = o.target,
          i = t.querySelector("#mobileMenu");
        if (
          e.contains(r) ||
          r === e ||
          (i && (i.contains(r) || r === i))
        )
          return !1;
        e.classList.contains("active") &&
          (e.classList.remove("active"),
          document.querySelector("body").classList.remove("nav-open"),
          setTimeout(() => {
            Array.from(t.querySelectorAll(".child")).forEach(function (e) {
              DOMAnimations.slideUp(e);
            });
          }, 200));
      }));
    let o = t.querySelectorAll("[data-submenu-trigger]");
    Array.from(o).forEach(function (e) {
      e.addEventListener("click", function (o) {
        o.preventDefault();
        let r = e.dataset.submenuTrigger,
          i = t.querySelector('[data-inner-item="' + r + '"]');
        e.classList.contains("active")
          ? (e.classList.remove("active"),
            e.closest(".nav-item-header").classList.remove("active-bg"),
            i && DOMAnimations.slideUp(i))
          : (e.classList.add("active"),
            e.closest(".nav-item-header").classList.add("active-bg"),
            i && DOMAnimations.slideDown(i));
      });
    });
    let r = t.querySelectorAll(".menu-tab");
    if (
      (Array.from(r).forEach(function (e) {
        e.addEventListener("click", function (o) {
          if ((o.preventDefault(), e.classList.contains("active"))) return !1;
          let r = t.querySelector(".menu-tab.active");
          (r && r.classList.remove("active"), e.classList.add("active"));
          let i = t.querySelector(".tabcontent." + e.dataset.tab),
            s = t.querySelector(".tabcontent.active");
          s &&
            i &&
            (Array.from(s.querySelectorAll(".child")).forEach(function (e) {
              DOMAnimations.slideUp(e);
            }),
            s.classList.add("hidden"),
            s.classList.remove("active"),
            i.classList.remove("hidden"),
            i.classList.add("active"));
        });
      }),
      t.classList.contains("sticky-header") &&
        "on_scroll" === t.dataset.stickyType)
    ) {
      let e = window.scrollY;
      document.addEventListener("scroll", function () {
        let o = 2 * t.offsetHeight;
        if (
          (window.scrollY > o
            ? e > window.scrollY
              ? (t.parentElement.classList.remove("sticky-header-hidden"),
                document
                  .querySelector("body")
                  .classList.remove("sticky-header-hide"))
              : document
                  .querySelector("body")
                  .classList.contains("search-drawer-open") ||
                (document
                  .querySelector("body")
                  .classList.contains("hamburger-open") ||
                  t.parentElement.classList.add("sticky-header-hidden"),
                setTimeout(function () {
                  t.parentElement.classList.add("scroll-sticky");
                }, 500),
                document
                  .querySelector("body")
                  .classList.add("sticky-header-hidden"))
            : (t.parentElement.classList.remove("sticky-header-hidden"),
              t.parentElement.classList.remove("scroll-sticky"),
              document
                .querySelector("body")
                .classList.remove("sticky-header-hidden")),
          (e = window.scrollY),
          t.parentElement.classList.contains("sticky-header-hidden"))
        )
          document
            .querySelector("body")
            .style.setProperty("--dynamicheaderHeight", "0px");
        else {
          let e = t.getBoundingClientRect().height.toFixed(2);
          document
            .querySelector("body")
            .style.setProperty("--dynamicheaderHeight", `${e}px`);
        }
      });
    } else
      t.classList.contains("sticky-header") ||
        t.parentElement.classList.remove("sticky");
    (document
      .querySelector("body")
      .style.setProperty("--headerHeight", `${t.parentElement.offsetHeight}px`),
      announementHeightOnScroll());
  } else
    document.querySelector("body").style.setProperty("--headerHeight", "0px");
}
function productGiftOptions(e = document) {
  let t = e.querySelectorAll("[data-gift-card-box]");
  Array.from(t).forEach(function (e) {
    let t = e.querySelector("[data-js-gift-card-selector]");
    t &&
      ((t.disabled = !1),
      t.addEventListener("click", function () {
        let o = e.querySelector("[data-gift-card-content]");
        if (t.checked) DOMAnimations.slideDown(o, 500);
        else {
          DOMAnimations.slideUp(o, 500);
          let t = e.querySelector(".form-message__wrapper");
          if (t) {
            t.classList.add("hidden");
            let e = t.querySelector(".error-message");
            e && (e.innerHTML = "");
          }
        }
      }));
    let o = e.querySelector("[data-no-js-gift-card-selector]");
    o && (o.disabled = !0);
  });
}
function colorMode() {
  let e = document.querySelectorAll(".toggle-checkbox");
  Array.from(e).forEach(function (e) {
    e.addEventListener("change", () => {
      e.checked
        ? (document.querySelector("html").setAttribute("color-mode", "dark"),
          (localStorage.darkMode = "true"))
        : (document.querySelector("html").setAttribute("color-mode", "light"),
          (localStorage.darkMode = "false"));
    });
  });
}
function quickNav(e = document) {
  let t = e.querySelectorAll(".product-filter-boxes button");
  Array.from(t).forEach(function (e) {
    e.addEventListener("click", function (t) {
      t.preventDefault();
      const o = e
        .closest(".product-filter-boxes")
        ?.querySelector(".quick-nav__listbox");
      (o && o.classList.toggle("active"), getSelectedvalue());
    });
  });
}
function getSelectedvalue(e = document) {
  let t = e
      .querySelector("[data-multiboxes-filter]")
      .closest(".shopify-section"),
    o = t.querySelector('.product-filter-boxes[data-level="1"]'),
    r = t.querySelector('.product-filter-boxes[data-level="2"]'),
    i = t.querySelector('.product-filter-boxes[data-level="3"]'),
    s = "",
    n = "";
  if (o && ((s = o.querySelector("ul.active")), s)) {
    let e = s.querySelectorAll("li.custom-select__option");
    Array.from(e).forEach(function (e) {
      e.addEventListener("click", function (e) {
        let t = !1;
        (e.preventDefault(), (n = this.getAttribute("data-value")));
        let a = this.querySelector("span.navigation_title").innerText;
        o.querySelector("button span.text_btn").innerHTML = a;
        let c = this.getAttribute("data-url");
        if (
          ("" != c &&
            document
              .querySelector("[data-navigation-url]")
              .setAttribute("href", c),
          r)
        ) {
          let e = r.querySelector("ul");
          if (e) {
            let o = e.querySelectorAll("li.custom-select__option");
            Array.from(o).forEach(function (o) {
              if (
                (o.getAttribute("data-parent-handle").includes(n)
                  ? ((t = !0), (o.style.display = "block"))
                  : ((o.style.display = "none"), e.classList.remove("active")),
                1 == t)
              )
                (o.closest(".custom-select").classList.remove("disabled_btn"),
                  s.classList.remove("active"));
              else {
                o.closest(".custom-select").classList.add("disabled_btn");
                let e = o
                  .closest(".custom-select")
                  .querySelector("button span.text_btn")
                  .getAttribute("data-placeholder-text");
                ((r.querySelector("button span.text_btn").innerHTML = e),
                  i
                    .querySelector(".custom-select")
                    .classList.add("disabled_btn"));
                let t = i
                  .querySelector("button span.text_btn")
                  .getAttribute("data-placeholder-text");
                ((i.querySelector("button span.text_btn").innerHTML = t),
                  document
                    .querySelector("[data-navigation-url]")
                    .classList.remove("disabled_btn"));
              }
              o.addEventListener("click", function (t) {
                t.preventDefault();
                let o = !1;
                getDatavalueThree = this.getAttribute("data-value");
                let s = this.querySelector("span.navigation_title").innerText;
                r.querySelector("button span.text_btn").innerHTML = s;
                let n = this.getAttribute("data-url");
                if (
                  ("" != n &&
                    document
                      .querySelector("[data-navigation-url]")
                      .setAttribute("href", n),
                  i)
                ) {
                  let t = i.querySelector("ul");
                  if (t) {
                    let r = t.querySelectorAll("li.custom-select__option");
                    Array.from(r).forEach(function (r) {
                      let s = r.getAttribute("data-parent-handle");
                      if (
                        (getDatavalueThree.includes(s)
                          ? ((o = !0), (r.style.display = "block"))
                          : ((r.style.display = "none"),
                            t.classList.remove("active")),
                        1 == o)
                      )
                        (r
                          .closest(".custom-select")
                          .classList.remove("disabled_btn"),
                          e.classList.remove("active"));
                      else {
                        (r
                          .closest(".custom-select")
                          .classList.add("disabled_btn"),
                          document
                            .querySelector("[data-navigation-url]")
                            .classList.remove("disabled_btn"));
                        let e = i
                          .querySelector("button span.text_btn")
                          .getAttribute("data-placeholder-text");
                        ((i.querySelector("button span.text_btn").innerHTML =
                          e),
                          document
                            .querySelector("[data-navigation-url]")
                            .classList.remove("disabled_btn"));
                      }
                      r.addEventListener("click", function (e) {
                        let o = this.getAttribute("data-url");
                        if ("" != o) {
                          let e = this.querySelector(
                            "span.navigation_title",
                          ).innerText;
                          ((i.querySelector("button span.text_btn").innerHTML =
                            e),
                            document
                              .querySelector("[data-navigation-url]")
                              .setAttribute("href", o),
                            t.classList.remove("active"),
                            document
                              .querySelector("[data-navigation-url]")
                              .classList.remove("disabled_btn"));
                        }
                      });
                    });
                  }
                }
              });
            });
          }
        }
      });
    });
  }
}
function ageVerifiedpopup() {
  let e = getCookie("ageVerified"),
    t = document.querySelector("[data-age-verification]");
  if (t) {
    if (
      "true" == t.getAttribute("data-age-verification-status") &&
      "true" != e &&
      window.location.pathname.indexOf("/challenge") < 0 &&
      null == Shopify.designMode
    ) {
      let e = document.querySelector(".age-verification");
      e &&
        (e.classList.add("active"),
        document.querySelector("body").classList.add("no-scroll"));
    }
  }
}
function closeVideoMedia(e = document, t) {
  (e.querySelectorAll(".youtube_video").forEach((e) => {
    (isOnScreen(e) && 0 != t) ||
      ("false" != e.dataset.autoplay &&
        !e.classList.contains("sr-youtube-video")) ||
      e.contentWindow.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}',
        "*",
      );
  }),
    e.querySelectorAll(".vimeo_video").forEach((e) => {
      (isOnScreen(e) && 0 != t) ||
        ("false" != e.dataset.autoplay &&
          !e.classList.contains("sr-vimeo-video")) ||
        e.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    e.querySelectorAll("video").forEach((e) => {
      (isOnScreen(e) && 0 != t) || e.hasAttribute("autoplay") || e.pause();
    }));
}
function newsletterofferPopup() {
  if (document.querySelector(".newsletter-popup")) {
    1 == newsletterofferFormSubmitted &&
      1 == newsletterofferPopupEnable &&
      setCookie(
        "newsletterofferPopUpClosed",
        "true",
        newsletterofferPopupExpDays,
      );
    let e = getCookie("newsletterofferPopUpClosed");
    if (
      0 == newsletterofferFormSubmitted &&
      1 == newsletterofferPopupEnable &&
      "true" != e &&
      window.location.pathname.indexOf("/challenge") < 0 &&
      null == Shopify.designMode
    ) {
      let e = document.querySelector(".newsletter-popup");
      e &&
        (e.classList.add("active"),
        document.querySelector("body").classList.add("no-scroll"));
    }
  }
}
DOMAnimations = {
  slideUp: function (e, t = 500) {
    return new Promise(function (o, r) {
      ((e.style.height = e.offsetHeight + "px"),
        (e.style.transitionProperty = "height, margin, padding"),
        (e.style.transitionDuration = t + "ms"),
        e.offsetHeight,
        (e.style.overflow = "hidden"),
        (e.style.height = 0),
        (e.style.paddingTop = 0),
        (e.style.paddingBottom = 0),
        (e.style.marginTop = 0),
        (e.style.marginBottom = 0),
        window.setTimeout(function () {
          ((e.style.display = "none"),
            e.style.removeProperty("height"),
            e.style.removeProperty("padding-top"),
            e.style.removeProperty("padding-bottom"),
            e.style.removeProperty("margin-top"),
            e.style.removeProperty("margin-bottom"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property"),
            o(!1));
        }, t));
    });
  },
  slideDown: function (e, t = 500) {
    return new Promise(function (o, r) {
      e.style.removeProperty("display");
      let i = window.getComputedStyle(e).display;
      ("none" === i && (i = "block"), (e.style.display = i));
      let s = e.offsetHeight;
      ((e.style.overflow = "hidden"),
        (e.style.height = 0),
        (e.style.paddingTop = 0),
        (e.style.paddingBottom = 0),
        (e.style.marginTop = 0),
        (e.style.marginBottom = 0),
        e.offsetHeight,
        (e.style.transitionProperty = "height, margin, padding"),
        (e.style.transitionDuration = t + "ms"),
        (e.style.height = s + "px"),
        e.style.removeProperty("padding-top"),
        e.style.removeProperty("padding-bottom"),
        e.style.removeProperty("margin-top"),
        e.style.removeProperty("margin-bottom"),
        window.setTimeout(function () {
          (e.style.removeProperty("height"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property"));
        }, t));
    });
  },
  slideToggle: function (e, t = 500) {
    return "none" === window.getComputedStyle(e).display
      ? this.slideDown(e, t)
      : this.slideUp(e, t);
  },
  classToggle: function (e, t) {
    e.classList.contains(t) ? e.classList.remove(t) : e.classList.add(t);
  },
};
function toggleAccountPopup(e, t) {
  e.preventDefault();
  e.target;
  if ("dropdown" == t) {
    let e = document.querySelector("[data-account-dropdown]");
    e && DOMAnimations.slideToggle(e, 250);
  }
}
class StoreDetailsPopup extends HTMLElement {
  constructor() {
    (super(), (this.toggleDropdown = this.toggleDropdown.bind(this)));
  }
  connectedCallback() {
    this.addEventListener("click", this.toggleDropdown);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.toggleDropdown);
  }
  toggleDropdown(e) {
    (e.preventDefault(), e.stopPropagation(), console.log("click"));
    let t = this.querySelector("[data-storedetails-dropdown]");
    t && DOMAnimations.slideToggle(t, 250);
  }
}
function toggleForm(e) {
  e.preventDefault();
  let t = e.target,
    o = t.closest(".customer-account-popup"),
    r = o.querySelector("#" + t.dataset.close),
    i = o.querySelector("#" + t.dataset.open);
  i && r && ((r.style.display = "none"), (i.style.display = "block"));
}
function closeDropdowns() {
  var e = !1;
  (document
    .querySelectorAll(
      "[data-account-dropdown], .header-icons-link.account, [data-storedetails-dropdown], .support-content-wrapper",
    )
    .forEach((t) => {
      (t.addEventListener("mouseover", () => {
        e = !0;
      }),
        t.addEventListener("mouseout", () => {
          e = !1;
        }));
    }),
    document.body.addEventListener("click", () => {
      if (!e) {
        document.querySelector("[data-account-dropdown]") &&
          DOMAnimations.slideUp(
            document.querySelector("[data-account-dropdown]"),
          );
        let e = document.querySelectorAll("[data-storedetails-dropdown]");
        Array.from(e).forEach(function (e) {
          e && DOMAnimations.slideUp(e);
        });
      }
    }));
}
function imagesBanner(e = document) {
  let t = e.querySelectorAll("[data-banner-text]");
  Array.from(t).forEach(function (e) {
    let t = e.closest(".shopify-section");
    e.addEventListener("mouseover", function (o) {
      let r = e.dataset.blockId,
        i = t.querySelector("[data-banner-image].active"),
        s = t.querySelector(`[data-banner-image][data-block-id="${r}"]`),
        n = t.querySelector("[data-banner-text].active"),
        a = t.querySelector(`[data-banner-text][data-block-id="${r}"]`);
      (s && (i && i.classList.remove("active"), s.classList.add("active")),
        a && (n && n.classList.remove("active"), a.classList.add("active")));
    });
  });
}
function categoriesSidebar(e = document) {
  const t = e.querySelectorAll("[data-categories-btn]"),
    o = e.querySelectorAll("[data-categories-wrapper]"),
    r = e.querySelectorAll("[data-categories-close]"),
    i = e.querySelectorAll("[data-sidebar-overlay]"),
    s = document.body;
  t.forEach((e, t) => {
    const n = o[t],
      a = r[t],
      c = i[t];
    (e &&
      n &&
      e.addEventListener("click", function (e) {
        (e.preventDefault(),
          n.classList.add("active"),
          s.classList.add("sidebar-category-overlay"));
      }),
      a &&
        n &&
        a.addEventListener("click", function (e) {
          (e.preventDefault(),
            n.classList.contains("active") &&
              setTimeout(() => {
                (n.classList.remove("active"),
                  s.classList.remove("sidebar-category-overlay"));
              }, 100));
        }),
      c &&
        a &&
        c.addEventListener("click", function (e) {
          (e.preventDefault(), console.log("click"), console.log(a), a.click());
        }));
  });
}
function headerHamburgerMenu(e = document) {
  if (window.echoHamburgerBound) return;
  if (document.querySelector("[data-hamburger-menu]")) {
    window.echoHamburgerBound = true;
    let e = document.querySelector("[data-hamburger-menu]");
    e.addEventListener("click", function (t) {
      t.preventDefault();
      let o = e.getAttribute("href"),
        r = document.querySelector(o),
        i = "close";
      if (r && !r.classList.contains("is-visible")) {
        ((r.style.display = "block"),
          document.body.classList.add("hamburger-open"),
          document.body.classList.add("no-scroll"));
        let e = r.querySelectorAll("[data-menu-items]");
        (setTimeout(() => {
          (r.classList.add("is-visible"), (i = "open"));
        }, 200),
          setTimeout(() => {
            "open" == i &&
              Array.from(e).forEach(function (e) {
                (e.classList.add("animation"),
                  setTimeout(function () {
                    e.classList.add("animated");
                  }, 100));
              });
          }, 700),
          (previousFocusElement = r),
          focusElementsRotation(r));
      }
    });
    let t = document.querySelectorAll("[data-hamburger-menu-close]");
    Array.from(t).forEach(function (e) {
      e.addEventListener("click", function (e) {
        e.preventDefault();
        let t = document.querySelector("[data-humburger-body]");
        if (!t) return;
        (setTimeout(() => {
          t.style.display = "none";
          let e = t.querySelectorAll("[data-menu-items]");
          Array.from(e).forEach(function (e) {
            e.classList.remove("animation", "animated");
          });
        }, 500),
          document.body.classList.remove("hamburger-open", "no-scroll"),
          t.classList.remove("is-visible"));
      });
    });
  }
}
function hamburgerHoverMenu() {
  let e = document.querySelectorAll("[data-menu-items]");
  Array.from(e).forEach(function (e) {
    e &&
      (e.addEventListener("mouseover", function (t) {
        (e.classList.add("active"),
          e.querySelector(".dropdown-menus-main") &&
            e.querySelector(".dropdown-menus-main").classList.add("active"));
      }),
      e.addEventListener("mouseleave", function (t) {
        (e.classList.remove("active"),
          e.querySelector(".dropdown-menus-main") &&
            e.querySelector(".dropdown-menus-main").classList.remove("active"));
      }));
  });
  let t = document.querySelectorAll("[data-menu-dropdown]");
  Array.from(t).forEach(function (e) {
    e &&
      e.addEventListener("click", function (t) {
        e.closest(".dropdown-menus-inner").classList.contains("active")
          ? e.closest(".dropdown-menus-inner").classList.remove("active")
          : e.closest(".dropdown-menus-inner").classList.add("active");
      });
  });
}
function initBeforeAfter(e = document) {
  let t = e.querySelectorAll("#before-after-cursor-point");
  Array.from(t).forEach(function (e) {
    beforeAfterImage(e);
  });
}
function beforeAfterImage(e) {
  let t = e.closest(".shopify-section");
  if (!e.offsetParent) return !1;
  e.addEventListener("input", function () {
    let e = t.querySelector(".before-after-main-image");
    ((e.style.clipPath = `polygon(0 0, ${this.value}% 0, ${this.value}% 100%, 0% 100%)`),
      e
        .closest(".before-after-wrapper")
        .style.setProperty("--position", this.value + "%"));
  });
}
function windowResize() {
  window.addEventListener("resize", function () {
    setTimeout(function () {
      initBeforeAfter();
    }, 500);
  });
}
function imageWithCarousel(e = document) {
  const t = document.querySelectorAll(".image-with-text-content");
  let o = t.length - 1;
  ((observer = new IntersectionObserver(
    (e) => {
      e.forEach((e) => {
        let t = e.target;
        if (e.intersectionRatio > 0.7) {
          let e = t.closest(".shopify-section"),
            r = t.getAttribute("data-card");
          (0 != r &&
            ((r -= 1),
            e
              .querySelector('[data-card="' + r + '"]')
              .classList.add("show-feature")),
            o == r + 1 && t.classList.add("show-feature"));
        } else t.classList.remove("show-feature");
      });
    },
    { threshold: 0.7 },
  )),
    t.forEach((e) => observer.observe(e)));
}
function addMultiplier(e = document) {
  let t = e.querySelectorAll("[data-product-wrapper]");
  Array.from(t).forEach(function (e) {
    let t = e.querySelectorAll("[data-add-multiplier]");
    Array.from(t).forEach(function (e) {
      e &&
        e.addEventListener("click", function (t) {
          t.preventDefault();
          let o = parseInt(this.getAttribute("data-value"));
          ((e
            .closest("[data-product-wrapper]")
            .querySelector("[data-quantity-input]").value = o),
            e
              .closest("[data-product-wrapper]")
              .querySelector("#sticky_quantity") &&
              (e
                .closest("[data-product-wrapper]")
                .querySelector("#sticky_quantity").value = o),
            setTimeout(function () {
              e.closest("[data-product-wrapper]")
                .querySelector("[data-add-to-cart]")
                .click();
            }, 100));
        });
    });
  });
}
(customElements.define("store-details-popup", StoreDetailsPopup),
  document.addEventListener("scroll", function () {
    (announementHeightOnScroll(),
      closeVideoMedia(),
      document.body.scrollTop > 300 || document.documentElement.scrollTop > 300
        ? document.querySelector(".compare-btn-sidebar") &&
          document.querySelector(".compare-btn-sidebar").classList.add("show")
        : document.querySelector(".compare-btn-sidebar") &&
          document
            .querySelector(".compare-btn-sidebar")
            .classList.remove("show"));
  }),
  document.addEventListener("resize", function () {
    productCardHoverInit();
  }));
let badgesInterval = 1e3 * bdageAnimationSeconds + 500;
function badgesAnimation(e = document) {
  let t = e.querySelectorAll(".product-card-badges");
  Array.from(t).forEach(function (e) {
    let t = 0,
      o = e.querySelectorAll(".custom-badge");
    o.length > 1 &&
      (Array.from(o).forEach(function (e, t) {
        0 != t && (e.style.display = "none");
      }),
      setInterval(function () {
        (o[t].fadeOut(500),
          (t += 1),
          t >= o.length && (t = 0),
          setTimeout(function () {
            o[t].fadeIn(500);
          }, 550));
      }, badgesInterval));
  });
}
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    let e = "";
    (this.closest(".product-gallery-img-item")
      ? (e = this.closest(".product-gallery-img-item").querySelector(
          ".js-load-media",
        ))
      : this.closest(".shopify-section") &&
        (e = this.closest(".shopify-section").querySelector(".js-load-media")),
      e
        ? e.addEventListener("click", this.loadContent.bind(this))
        : this.addObserver());
  }
  addObserver() {
    if ("IntersectionObserver" in window == !1) return;
    const e = new IntersectionObserver(
      (t) => {
        t.forEach((t) => {
          t.isIntersecting && (this.loadContent(), e.unobserve(this));
        });
      },
      { rootMargin: "0px 0px 900px 0px" },
    );
    e.observe(this);
  }
  loadContent() {
    if (!this.querySelector("template")) return !1;
    const e =
      this.querySelector("template").content.firstElementChild.cloneNode(!0);
    (this.appendChild(e),
      "youtube" == this.dataset.type &&
        onYouTubeIframeAPIReady(this.closest(".shopify-section")),
      ((this.querySelector("video") &&
        (this.querySelector("video").hasAttribute("autoplay") ||
          this.querySelector("video").hasAttribute("data-autoplay"))) ||
        (this.querySelector("video") &&
          this.querySelector("video").classList.contains("local_videos"))) &&
        this.querySelector("video").play());
    let t = this.querySelector(".deferred-media-placeholder");
    t &&
      ("vimeo" == this.dataset.type &&
        setTimeout(function () {
          t.style.display = "none";
        }, 2e3),
      this.querySelector("video") &&
        this.querySelector("video").addEventListener("playing", function () {
          t.style.display = "none";
        }),
      this.parentElement.classList.contains("parallax-image") &&
        new universalParallax(this).init({ speed: 10 }));
  }
}
customElements.define("deferred-media", DeferredMedia);
class DeferredSlider extends HTMLElement {
  constructor() {
    (super(), this.addObserver());
  }
  addObserver() {
    if ("IntersectionObserver" in window == !1) return;
    const e = new IntersectionObserver(
      (t) => {
        t.forEach((t) => {
          t.isIntersecting && (this.loadContent(), e.unobserve(this));
        });
      },
      { rootMargin: "0px 0px 700px 0px" },
    );
    e.observe(this);
  }
  loadContent() {
    if (!this.querySelector("template")) return !1;
    const e =
      this.querySelector("template").content.firstElementChild.cloneNode(!0);
    (this.appendChild(e),
      slideshowElements(this),
      customSliderArrowsEvents(this),
      quickviewElements(this),
      getCountDownElments(this),
      collectionSwatch(this),
      productCardHoverInit(this),
      badgesAnimation(this),
      aosAnimation && AOS && AOS.refreshHard());
  }
}
customElements.define("deferred-slider", DeferredSlider);
var lastScrollTopValue = 0;
class Timeline extends HTMLElement {
  constructor() {
    (super(),
      window.addEventListener(
        "scroll",
        this.timelineOnScrollHandler.bind(this),
      ));
  }
  timelineOnScrollHandler() {
    let e = this;
    this.contentItems = this.querySelectorAll("[data-content-item]");
    var t = window.pageYOffset || document.documentElement.scrollTop;
    (Array.from(this.contentItems).forEach(function (o) {
      const r = window.innerHeight / 2,
        { top: i, bottom: s } = o
          .querySelector(".timeline-content-text")
          .getBoundingClientRect();
      if (t > lastScrollTopValue) {
        if (r > i && s > 0) {
          if (o.querySelector(".timeline-image").classList.contains("active"))
            return !1;
          (e.querySelector(".timeline-image.active") &&
            e
              .querySelector(".timeline-image.active")
              .classList.remove("active"),
            o.querySelector(".timeline-image").classList.add("active"));
        }
      } else if (i < r && s > r) {
        let t = o.getAttribute("data-id");
        if (
          ((t = parseInt(t) + 1),
          o.querySelector(".timeline-image").classList.contains("active"))
        )
          return !1;
        (e.querySelector(".timeline-image.active") &&
          e.querySelector(".timeline-image.active").classList.remove("active"),
          o.querySelector(".timeline-image").classList.add("active"));
      }
    }),
      (lastScrollTopValue = t));
  }
}
function markeranimation(e = document) {
  let t = e.querySelectorAll(".marker-svg path");
  Array.from(t).forEach(function (e) {
    isOnScreen(e) &&
      e.closest(".marker-svg") &&
      setTimeout(function () {
        e.closest(".marker-svg").classList.add("marker-animation");
      }, 500);
  });
}
function announcementSocialWidth() {
  let e = document.querySelector(".announcement-bar-left");
  if (e) {
    let t = e.offsetWidth;
    document
      .querySelector("body")
      .style.setProperty("--announce-social-width", t + "px");
  }
}
function sectionLoadSelector() {
  document.querySelectorAll("section").forEach((e) => {
    let t = e.querySelectorAll(".marker-svg path");
    (Array.from(t).forEach(function (e) {
      isOnScreen(e) &&
        e.closest(".marker-svg") &&
        setTimeout(function () {
          e.closest(".marker-svg").classList.add("marker-animation");
        }, 500);
    }),
      isOnScreen(e) &&
        (e.classList.contains("before-after-image")
          ? setTimeout(function () {
              (e.classList.contains("section-in-view") ||
                (e
                  .querySelector(".before-after-wrapper")
                  .classList.add("animating"),
                setTimeout(function () {
                  e.querySelector(".before-after-wrapper").classList.remove(
                    "animating",
                  );
                }, 1e3)),
                e.classList.add("section-in-view"));
            }, 1e3)
          : setTimeout(function () {
              e.classList.add("section-in-view");
            }, 500)));
  });
}
function onloadEvents() {
  function run(fn) {
    try {
      fn();
    } catch (err) {
      console.error(err);
    }
  }
  run(announementHeightOnScroll);
  run(videoPlayInit);
  run(toggleVideoAudio);
  run(announcementSocialWidth);
  run(slideshowElements);
  run(menuDropdown);
  run(mobileNavigation);
  run(compareBarViewToggle);
  run(search_drawer);
  run(bundleProductInit);
  run(get_header_height);
  run(quickviewElements);
  run(footerDropdownCheck);
  run(search_drawer_tab);
  run(accordion);
  run(cartNoteUpdate);
  run(collectionSwatch);
  run(customSliderArrowsEvents);
  run(getCountDownElments);
  run(marqueeTextAutoplay);
  run(initStoreLocator);
  run(getAllDetails);
  run(onHoverMenuElements);
  run(headerNavigationPosition);
  run(customDropdownElements);
  run(function () {
    new IntersectionObserver(function (e) {
      let t = e.filter((e) => e.isIntersecting),
        o = document.querySelector("body");
      t.length > 0
        ? ((t = t[0].target), o.classList.add("overflow-hidden"))
        : o.classList.remove("overflow-hidden");
    });
  });
  run(lookbook);
  run(vertical_scroll);
  run(getcollageElments);
  run(detailDisclouserInit);
  run(tab_media_item);
  run(videoBanner);
  run(initHotspot);
  run(testimonialInit);
  run(SidedrawerEventInit);
  run(productRecommendations);
  run(recentlyViewedProducts);
  run(thumbnailChange);
  run(mp4VideoReady);
  run(vimeoVideoReady);
  run(outSideClickTrigger);
  run(collectionCarousal);
  run(collectionTabs);
  run(scrollTop);
  run(announcementCollapsiblecontent);
  run(checkedboxCookies);
  run(CloseCompareModel);
  run(showMoremedia);
  run(colorMode);
  run(productGiftOptions);
  run(quickNav);
  run(ageVerifiedpopup);
  run(newsletterofferPopup);
  run(productCardHoverInit);
  run(closeDropdowns);
  run(featuredImages);
  run(collectionCardImageCarousel);
  run(revealCollection);
  run(imagesBanner);
  run(cartTermhandlerClick);
  run(stickyFooterInit);
  run(needHelpTabs);
  run(cartTermsHandler);
  run(categoriesSidebar);
  run(initBeforeAfter);
  run(windowResize);
  run(addMultiplier);
  run(imageWithCarousel);
  run(badgesAnimation);
  run(headerHamburgerMenu);
  run(hamburgerHoverMenu);
  run(markeranimation);
  run(sectionLoadSelector);
  run(function () {
    aosAnimation && AOS && AOS.refreshHard();
  });
}
function revealCollection(e = document) {
  let t = e.querySelectorAll("[data-reveal]");
  Array.from(t).forEach(function (e) {
    (e.addEventListener("mouseover", function (t) {
      if (window.innerWidth < 768) return !1;
      let o = e.querySelector("[data-reveal-image]");
      o && (e.classList.add("active"), o.classList.add("active"));
    }),
      e.addEventListener("mousemove", function (t) {
        if (window.innerWidth < 768) return !1;
        let o = e.querySelector("img");
        if (o) {
          let r = getMousePos(t),
            i = r.x - e.offsetWidth / 2,
            s = r.y - e.offsetHeight / 2;
          o.style.translate = `${i}px ${s}px`;
        }
      }),
      e.addEventListener("mouseout", function (t) {
        if (window.innerWidth < 768) return !1;
        let o = e.querySelector("[data-reveal-image]");
        o &&
          (e.classList.remove("active"),
          o.classList.remove("active"),
          setTimeout(function () {
            o.style.translate = "0px 0px";
          }, 500));
      }));
  });
}
function toggleVideoAudio(e = document) {
  let t = e.querySelectorAll("[data-video-audio]");
  Array.from(t).forEach(function (e) {
    e.addEventListener("click", function (t) {
      let o = e.closest(".short-video-content");
      o.querySelector("video") &&
        (e.classList.contains("active")
          ? (e.classList.remove("active"),
            (o.querySelector("video").muted = !0))
          : (e.classList.add("active"), (o.querySelector("video").muted = !1)));
    });
  });
}
try {
  customElements.define("time-line-content", Timeline);
} catch (err) {
  console.error(err);
}
window.addEventListener("scroll", function () {
  sectionLoadSelector();
});
(function () {
    function e() {
      let e = document.querySelectorAll(
        "[data-search-form], form.predictive-search, form.search",
      );
      Array.from(e).forEach(function (e) {
        (e.setAttribute("action", "/search"), (e.action = "/search"));
      });
    }
    (document.addEventListener(
      "submit",
      function (e) {
        let t = e.target;
        if (("FORM" !== t.tagName && (t = t.closest("form")), !t)) return;
        if (
          !t.classList.contains("predictive-search") &&
          !t.classList.contains("search") &&
          !t.hasAttribute("data-search-form")
        )
          return;
        (e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation());
        let o = t.querySelector('[name="q"], [data-search-input]'),
          r = "";
        o && (r = o.value.trim());
        let i = t.querySelector('input[name="type"]'),
          s = "product,collection";
        i && (s = i.value);
        let n = "/search?q=" + encodeURIComponent(r);
        return (
          s && (n += "&type=" + encodeURIComponent(s)),
          (window.location.href = n),
          !1
        );
      },
      !0,
    ),
      e(),
      "loading" === document.readyState &&
        document.addEventListener("DOMContentLoaded", e));
  })();
document.addEventListener("DOMContentLoaded", function () {
    try {
      onloadEvents();
    } catch (err) {
      console.error(err);
    }
    [
      slideshowElements,
      collectionSwatch,
      marqueeTextAutoplay,
      customSliderArrowsEvents,
      collectionCarousal,
      testimonialInit,
      SidedrawerEventInit,
      cartTermhandlerClick,
      mobileNavigation,
      headerHamburgerMenu,
      hamburgerHoverMenu,
      search_drawer,
      menuDropdown,
    ].forEach(function (fn) {
      if (typeof fn === "function") {
        try {
          fn();
        } catch (err) {
          console.error(err);
        }
      }
    });
  });
const AUTHORITY_TO_LEAVE_ATTRIBUTE = "Authority to Leave";
function getAuthorityToLeaveRadios(e) {
  return (e || document).querySelectorAll(
    "[data-cart-checkout-agreement-authority-to-leave]",
  );
}
function getSelectedAuthorityToLeaveValue(e) {
  const t = getAuthorityToLeaveRadios(e);
  for (let e = 0; e < t.length; e++)
    if (t[e].checked) return "yes" === t[e].value ? "Yes" : "No";
  return null;
}
function saveAuthorityToLeaveAttribute(e) {
  const t = getSelectedAuthorityToLeaveValue(e);
  return null === t || "undefined" == typeof cartUpdateUrl
    ? Promise.resolve()
    : fetch(cartUpdateUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          attributes: { [AUTHORITY_TO_LEAVE_ATTRIBUTE]: t },
        }),
      });
}
function cartTermhandlerClick() {
  (window.__cartCheckoutAgreementsDelegated ||
    ((window.__cartCheckoutAgreementsDelegated = !0),
    document.addEventListener("change", function (e) {
      if (e.target && e.target.matches)
        if (
          e.target.matches("[data-cart-checkout-agreement-authority-to-leave]")
        ) {
          cartTermsHandler();
          saveAuthorityToLeaveAttribute(
            e.target.closest(".cart-checkout-inner, .cart-btn-container"),
          );
        } else
          e.target.matches("[data-cart-checkout-agreement]") &&
            cartTermsHandler();
    }),
    document.addEventListener("submit", function (e) {
      const t = e.target;
      if (!t || !t.matches("#cart, #mainCartForm")) return;
      if (window.Shopify && Shopify.designMode) return;
      const o = e.submitter;
      if (!o || "checkout" !== o.name) return;
      if ("true" === t.dataset.authoritySaving) return;
      const r =
        o.closest(".cart-checkout-inner, .cart-btn-container") ||
        t.closest(".cart-checkout-inner") ||
        document;
      if (0 === getAuthorityToLeaveRadios(r).length) return;
      e.preventDefault();
      t.dataset.authoritySaving = "true";
      saveAuthorityToLeaveAttribute(r)
        .catch(function () {})
        .finally(function () {
          "function" == typeof t.requestSubmit ? t.requestSubmit(o) : t.submit();
        });
    })),
    cartTermsHandler());
}
function cartTermsHandler() {
  document.querySelectorAll('[name="checkout"]').forEach(function (e) {
    if (!e) return;
    const t =
      e.closest(".cart-checkout-inner, .cart-btn-container") || document;
    let o = t.querySelectorAll(
        "[data-cart-checkout-agreement]:not([data-cart-checkout-agreement-optional])",
      ),
      r = !0;
    o.forEach(function (e) {
      e.checked || (r = !1);
    });
    const i = t.querySelectorAll(
      "[data-cart-checkout-agreement-authority-to-leave]",
    );
    (i.length > 0 && null === getSelectedAuthorityToLeaveValue(t) && (r = !1),
      (0 === o.length && 0 === i.length) || r
        ? e.removeAttribute("disabled")
        : e.setAttribute("disabled", !0));
  });
}
if ("function" != typeof ImageWithTextCarousel) {
  class e extends HTMLElement {
    constructor() {
      (super(), this.init());
    }
    init() {
      ((this.slides = []),
        (this.slide = 0),
        this.querySelectorAll(".image-with-text-content").forEach((e) => {
          this.slides.push({
            parent: e,
            children: e.querySelector(".row"),
            media: e.querySelectorAll(".image-with-text-image-wrapper"),
            text: e.querySelector(".image-with-text-carousel-content"),
          });
        }),
        (this.zoomEffect = !0),
        (this.paralex = !1),
        (this.slideRaf = !0),
        (this.onScrollHandler = (() => {
          this.slideRaf &&
            ((this.slideRaf = !1),
            this.slides.length > 0 &&
              requestAnimationFrame(this.CarouselAnimation.bind(this)));
        }).bind(this)),
        window.addEventListener("scroll", this.onScrollHandler, {
          passive: !0,
        }),
        window.addEventListener("resize", this.onScrollHandler, {
          passive: !0,
        }),
        this.onScrollHandler());
    }
    CarouselAnimation(e) {
      const t = this.parentElement.getBoundingClientRect().y + window.scrollY,
        o = window.scrollY,
        r = Math.min(
          this.slides[0].children.offsetHeight,
          window.innerHeight +
            (this.classList.contains("vertical-slider--no-padding") ? 0 : 20) -
            0,
        );
      (this.parentElement.classList.add("has-children-" + this.slides.length),
        this.slides.forEach((e, i) => {
          let s = o - t + (window.innerHeight - r) - r * i,
            n = s - (window.innerHeight - r);
          e.media[0] &&
            e.parent.getBoundingClientRect().y < window.innerHeight &&
            e.parent.getBoundingClientRect().y > -window.innerHeight &&
            (o <= t
              ? 0 == i ||
                e.parent.getBoundingClientRect().y + e.parent.offsetHeight <=
                  window.innerHeight
                ? this.classList.contains("fullwidth-wrapper")
                  ? e.media.forEach((e) => {
                      e.style.transform =
                        "" + (this.paralex ? "translateY(0)" : "");
                    })
                  : (e.media.forEach((e) => {
                      e.style.transform = `${this.zoomEffect ? "scale(1)" : ""} ${this.paralex ? "translateY(0)" : ""}`;
                    }),
                    (e.children.style.transform = "scale(1)"))
                : this.classList.contains("fullwidth-wrapper")
                  ? e.media.forEach((e) => {
                      const t = 100 - (100 * s) / r / 12;
                      e.style.transform =
                        "" +
                        (this.paralex
                          ? `translateY(${t <= 100 ? 0 : s / 2}px)`
                          : "");
                    })
                  : (e.media.forEach((e) => {
                      const t = 100 - (100 * s) / r / 12;
                      e.style.transform = `${this.zoomEffect ? `scale(${Math.max(100, t)}%)` : ""} ${this.paralex ? `translateY(${t <= 100 ? 0 : s / 2}px)` : ""}`;
                    }),
                    (e.children.style.transform =
                      "" + (this.zoomEffect ? "scale(1)" : "")))
              : s < 0
                ? this.classList.contains("fullwidth-wrapper")
                  ? e.media.forEach((e) => {
                      e.style.transform =
                        "" + (this.paralex ? `translateY(${s / 2}px)` : "");
                    })
                  : e.media.forEach((e) => {
                      e.style.transform = `${this.zoomEffect ? `scale(${100 - (100 * s) / r / 12}%)` : ""} ${this.paralex ? `translateY(${s / 2}px)` : ""}`;
                    })
                : s >= 0 && n <= 0
                  ? this.classList.contains("fullwidth-wrapper")
                    ? e.media.forEach((e) => {
                        e.style.transform =
                          "" + (this.paralex ? "translateY(0)" : "");
                      })
                    : (e.media.forEach((e) => {
                        e.style.transform = `${this.zoomEffect ? "scale(1)" : ""} ${this.paralex ? "translateY(0)" : ""}`;
                      }),
                      (e.children.style.transform =
                        "" + (this.zoomEffect ? "scale(1)" : "")))
                  : n > 0 &&
                    i != this.slides.length - 1 &&
                    (this.classList.contains("fullwidth-wrapper")
                      ? e.media.forEach((e) => {
                          e.style.transform =
                            "" +
                            (this.paralex ? `translateY(${-n / 4}px)` : "");
                        })
                      : (e.media.forEach((e) => {
                          e.style.transform =
                            "" +
                            (this.paralex ? `translateY(${-n / 4}px)` : "");
                        }),
                        (e.children.style.transform =
                          "" +
                          (this.zoomEffect
                            ? `scale(${100 - (100 * n) / r / 40}%)`
                            : "")))));
        }),
        (this.slideRaf = !0));
    }
  }
  void 0 === customElements.get("image-with-text-carousel") &&
    customElements.define("image-with-text-carousel", e);
}
function needHelpTabs(e = document) {
  let t = e.querySelectorAll("[data-help-tab]");
  Array.from(t).forEach(function (e) {
    e.addEventListener("click", function () {
      if (e.classList.contains("active")) return !1;
      let t = e.closest("[data-help-tab-wrapper]");
      if (t) {
        let o = t.querySelector("#" + e.dataset.tab);
        if (o) {
          let r = t.querySelector(".help-list-tab-content-item.active");
          r && (r.classList.remove("active"), r.fadeOut(100));
          let i = t.querySelector(".help-list-tab-item.active");
          (i && i.classList.remove("active"),
            e.classList.add("active"),
            o.classList.add("active"),
            setTimeout(() => {
              o.fadeIn(300);
            }, 200));
        }
      }
    });
  });
}
function stickyFooterInit(e = document) {
  const t = e.querySelector("[data-footer-sticky]");
  if (t) {
    const e = new IntersectionObserver(
      (o) => {
        o.forEach((o) => {
          o.isIntersecting &&
            (document.body.classList.add("footer-sticky"), e.unobserve(t));
        });
      },
      { rootMargin: `0px 0px ${document.body.scrollHeight / 3}px 0px` },
    );
    e.observe(t);
  }
}
function footerDropdownCheck() {
  window.addEventListener("scroll", function () {
    let e = window.innerHeight / 2;
    if (document.querySelector(".footer-bottom")) {
      let t = document
        .querySelector(".footer-bottom")
        .getBoundingClientRect().top;
      isOnScreen(document.querySelector(".footer-bottom")) &&
        (t < e
          ? document.querySelector(".footer-bottom").classList.add("bottom")
          : document
              .querySelector(".footer-bottom")
              .classList.remove("bottom"));
    }
    if (document.querySelector(".footer-newsletter-localization")) {
      let t = document
        .querySelector(".footer-newsletter-localization")
        .getBoundingClientRect().top;
      isOnScreen(document.querySelector(".footer-newsletter-localization")) &&
        (t < e
          ? document
              .querySelector(".footer-newsletter-localization")
              .classList.add("bottom")
          : document
              .querySelector(".footer-newsletter-localization")
              .classList.remove("bottom"));
    }
  });
}
class OdoMeter extends HTMLElement {
  constructor() {
    (super(), this.addObserver());
  }
  addObserver() {
    if ("IntersectionObserver" in window == !1) return;
    const e = new IntersectionObserver(
      (t) => {
        t.forEach((t) => {
          t.isIntersecting && (this.loadContent(), e.unobserve(this));
        });
      },
      { rootMargin: "0px 0px -300px 0px" },
    );
    e.observe(this);
  }
  loadContent() {
    let e = $(this);
    $({ Counter: 0 }).animate(
      { Counter: e.data("counter") },
      {
        duration: 2e3,
        easing: "swing",
        step: function () {
          e.text(Math.ceil(this.Counter));
        },
        complete: function () {
          e.text(e.data("counter"));
        },
      },
    );
  }
}
customElements.define("odo-meter", OdoMeter);
class CategorisList extends HTMLElement {
  constructor() {
    (super(),
      Array.from(this.querySelectorAll("[data-content-item]")).forEach((e) => {
        e.addEventListener("mouseover", this.onActionHandler.bind(this, e));
      }));
  }
  onActionHandler(e) {
    const t = this.closest("section");
    if (e.classList.contains("active")) return;
    const o = this.querySelector("[data-image-item].active");
    (o &&
      (o.classList.remove("active"),
      o.classList.add("processing"),
      setTimeout(() => {
        o.classList.remove("processing");
      }, 400)),
      Array.from(this.querySelectorAll("[data-content-item]")).forEach((e) => {
        e.classList.remove("active");
      }),
      e.classList.add("active"));
    const r = t.querySelector(
      `[data-image-item="categories-image-item-${e.dataset.contentItem}"]`,
    );
    (r && r.classList.add("active"),
      t.querySelectorAll("[data-image-item]").forEach((e) => {
        e.classList.contains("active")
          ? (e.style.zIndex = "3")
          : (e.style.zIndex = "1");
      }));
  }
}
customElements.define("categories-list", CategorisList);
class QuantityBasedPrice extends HTMLElement {
  static observedAttributes = ["qty-in-cart"];
  constructor() {
    (super(),
      (this.parent = this.closest("[data-product-quantity-wrapper]")),
      (this.input = this.parent?.querySelector("[data-quantity-input]")),
      (this.pricePerItemSelector = this.querySelector(
        "[price-per-item--current]",
      )),
      (this.cartItemLabelSelector = this.querySelector("[data-items-in-cart]")),
      (this.dataArray = []),
      this.querySelector("[data-variant-price-breaks]") &&
        "" != this.querySelector("[data-variant-price-breaks]").textContent &&
        (this.dataArray = JSON.parse(
          this.querySelector("[data-variant-price-breaks]").textContent,
        )),
      0 != this.dataArray.length &&
        this.input &&
        this.input.addEventListener("change", this._updatePrice.bind(this)));
  }
  _updatePrice() {
    if (this.dataArray.length > 0 && this.input && this.pricePerItemSelector) {
      ((this.Qty = parseInt(this.input.value)),
        (this.cartQty = parseInt(this.input.dataset.cartQty)),
        (this.step = parseInt(this.input.step)));
      let e = this.cartQty + this.Qty;
      for (let t of this.dataArray)
        if (e >= t.qty) {
          this.pricePerItemSelector.innerHTML = t.label;
          break;
        }
    }
  }
  attributeChangedCallback(e, t, o) {
    "qty-in-cart" == e &&
      (this._updateCartText(o), this._updateInput(o), this._updatePrice());
  }
  _updateCartText(e) {
    this.cartItemLabelSelector &&
      ((this.cartItemLabelSelector.innerHTML = this.dataset.cartLabel.replace(
        "{{ item }}",
        e,
      )),
      parseInt(e) > 0
        ? this.cartItemLabelSelector.classList.remove("hidden")
        : this.cartItemLabelSelector.classList.add("hidden"));
  }
  _updateInput(e) {
    if (this.input) {
      this.input.dataset.cartQty = e;
      const t = this.input.dataset.cartQty
          ? parseInt(this.input.dataset.cartQty)
          : 0,
        o = this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        r = this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        i = this.input.step ? parseInt(this.input.step) : 1;
      let s = o;
      const n = null === r ? r : r - t;
      (null !== n && (s = Math.min(s, n)),
        t >= o && (s = Math.min(s, i)),
        (this.input.min = s),
        n ? (this.input.max = n) : this.input.removeAttribute("max"),
        (this.input.value = s));
    }
  }
}
customElements.define("quantity-based-price", QuantityBasedPrice);
class CartItemQuantity extends HTMLElement {
  constructor() {
    (super(),
      (this.selector = `quantity-based-price[data-variant-id="${this.dataset.variant}"]`));
    const e = this.dataset.quantity;
    Array.from(document.querySelectorAll(this.selector)).forEach(function (t) {
      t.setAttribute("qty-in-cart", e);
    });
  }
}
customElements.define("cart-item-quantity", CartItemQuantity);
class MediaLightBoxViewerModal extends HTMLElement {
  constructor() {
    (super(),
      (this.img = null),
      (this.container = null),
      (this.isZoomed = !1),
      (this.scale = 1),
      (this.startDistance = 0),
      (this.currentScale = 1),
      (this.pointers = []),
      (this.slider = null),
      (this.mouseMoveHandler = this.mouseMoveHandler.bind(this)),
      (this.zoomOut = this.zoomOut.bind(this)),
      (this.onPointerDown = this.onPointerDown.bind(this)),
      (this.onPointerMove = this.onPointerMove.bind(this)),
      (this.onPointerUp = this.onPointerUp.bind(this)));
  }
  connectedCallback() {
    this.initLightboxViewer();
  }
  swiperSlide() {
    ((this.sliderSelector = this.querySelector("[data-slideshow]")),
      this.sliderSelector &&
        (this.slider = Flickity.data(this.sliderSelector)));
  }
  initLightboxViewer() {
    this.querySelectorAll(".product-media-popup-slider-item img").forEach(
      (e) => {
        const t = e.parentElement;
        ("static" === getComputedStyle(t).position &&
          (t.style.position = "relative"),
          (t.style.overflow = "hidden"),
          (e.style.width = "100%"),
          (e.style.transition = "transform 0.2s ease"),
          (e.style.transformOrigin = "center center"),
          (e.style.cursor = "zoom-in"),
          (e.style.touchAction = "none"),
          e.addEventListener("click", (o) => this.toggleZoom(o, e, t)),
          e.addEventListener("pointerdown", this.onPointerDown),
          window.addEventListener("scroll", this.zoomOut));
      },
    );
  }
  toggleZoom(e, t, o) {
    (e.preventDefault(),
      e.stopPropagation(),
      this.isZoomed
        ? this.zoomOut()
        : ((this.img = t),
          (this.container = o),
          (this.isZoomed = !0),
          (t.style.cursor = "zoom-out"),
          (t.style.transform = "scale(2)"),
          o.addEventListener("mousemove", this.mouseMoveHandler),
          o.addEventListener("pointermove", this.onPointerMove),
          o.addEventListener("pointerup", this.onPointerUp),
          o.addEventListener("pointercancel", this.onPointerUp),
          o.addEventListener("pointerleave", this.onPointerUp),
          this.slider &&
            ((this.slider.options.draggable = !1),
            this.slider.updateDraggable())));
  }
  mouseMoveHandler(e) {
    if (!this.img || !this.isZoomed) return;
    const t = this.container.getBoundingClientRect(),
      o = e.clientX - t.left,
      r = e.clientY - t.top,
      i = (o / t.width) * 100,
      s = (r / t.height) * 100;
    this.img.style.transformOrigin = `${i}% ${s}%`;
  }
  onPointerDown(e) {
    "touch" === e.pointerType &&
      (this.pointers.push({
        pointerId: e.pointerId,
        clientX: e.clientX,
        clientY: e.clientY,
      }),
      2 === this.pointers.length &&
        (this.startDistance = this.getDistance(
          this.pointers[0],
          this.pointers[1],
        )));
  }
  onPointerMove(e) {
    if (this.pointers.length < 2) return;
    const t = this.pointers.find((t) => t.pointerId === e.pointerId);
    if (
      (t && ((t.clientX = e.clientX), (t.clientY = e.clientY)),
      2 === this.pointers.length)
    ) {
      const e = this.getDistance(this.pointers[0], this.pointers[1]);
      if (!this.startDistance) return void (this.startDistance = e);
      const t = e / this.startDistance;
      ((this.currentScale = Math.min(Math.max(this.scale * t, 1), 4)),
        (this.img.style.transform = `scale(${this.currentScale})`));
    }
  }
  onPointerUp(e) {
    ((this.pointers = this.pointers.filter((t) => t.pointerId !== e.pointerId)),
      this.pointers.length < 2 &&
        ((this.scale = this.currentScale), (this.startDistance = 0)));
  }
  getDistance(e, t) {
    const o = e.clientX - t.clientX,
      r = e.clientY - t.clientY;
    return Math.sqrt(o * o + r * r);
  }
  zoomOut() {
    this.img &&
      this.isZoomed &&
      ((this.img.style.transform = "scale(1)"),
      (this.img.style.cursor = "zoom-in"),
      this.container.removeEventListener("mousemove", this.mouseMoveHandler),
      this.container.removeEventListener("pointermove", this.onPointerMove),
      this.container.removeEventListener("pointerup", this.onPointerUp),
      this.container.removeEventListener("pointercancel", this.onPointerUp),
      this.container.removeEventListener("pointerleave", this.onPointerUp),
      (this.isZoomed = !1),
      this.slider &&
        ((this.slider.options.draggable = !0), this.slider.updateDraggable()),
      (this.img = null),
      (this.container = null),
      (this.scale = 1),
      (this.currentScale = 1),
      (this.startDistance = 0),
      (this.pointers = []));
  }
}
customElements.define("media-lightbox-viewer", MediaLightBoxViewerModal);
